/* ============================================================
   Five Star Silver — Shopify Theme JS
   Handles: dark mode, search/filter, sort, cart (AJAX),
   cart drawer, floating cart bar, product modal, sticky search.
   ============================================================ */

(function () {
  'use strict';

  /* ---- URL CLEANUP ----
     Strip Shopify's `pb=0` query param from the address bar without reloading.
     `pb` ("password-bypass") is added by Shopify when the storefront has a
     password page enabled — once a visitor is past it, the param tags along
     on every link. Removing it from the URL bar is purely visual; it doesn't
     affect routing or session state. Also strips a few other common Shopify
     analytics params (`_kx`, `_pos`, `_psq`, `_sid`, `_ss`, `_v`) if present. */
  (function cleanUrl() {
    if (!window.URLSearchParams || !window.history || !window.history.replaceState) return;
    var STRIP_KEYS = ['pb', '_kx', '_pos', '_psq', '_sid', '_ss', '_v'];
    var params = new URLSearchParams(window.location.search);
    var changed = false;
    STRIP_KEYS.forEach(function (k) {
      if (params.has(k)) { params.delete(k); changed = true; }
    });
    if (!changed) return;
    var qs = params.toString();
    var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    try { window.history.replaceState({}, '', newUrl); } catch (e) {}
  })();

  /* ---- HELPERS ---- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var fmt = window.fss && window.fss.moneyFormat ? window.fss.moneyFormat : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  /* ---- SHARED 50%-OFF LOGIC ----
     When a cart has 5+ items total, every line is halved (with a $1-per-item
     minimum so nothing drops below $1). Returns the original and discounted
     totals in cents plus whether the discount is active. Used by the cart
     drawer, the floating cart bar, and the custom checkout page so all three
     agree on the price. Exposed on window so the checkout page's own script
     can reuse it. */
  function fssCartDiscount(cart) {
    var MIN_QTY = 5;
    /* Original = sum of the full line prices (NOT cart.total_price, which a Shopify
       cart-level discount may have already halved — that made the bar show the same
       price crossed out and bold). This matches the drawer's struck-through subtotal. */
    var original = (cart && cart.items && cart.items.length)
      ? cart.items.reduce(function (s, it) { return s + ((it.final_line_price != null ? it.final_line_price : it.line_price) || 0); }, 0)
      : (cart ? (cart.total_price || 0) : 0);
    if (!cart || cart.item_count < MIN_QTY || !cart.items || !cart.items.length) {
      return { active: false, original: original, discounted: original };
    }
    var discounted = cart.items.reduce(function (sum, item) {
      var line = (item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      var half = Math.floor(line * 0.5);
      var minLine = 100 * item.quantity; /* $1 minimum per item */
      return sum + Math.max(half, minLine);
    }, 0);
    return { active: true, original: original, discounted: discounted };
  }
  window.fssCartDiscount = fssCartDiscount;

  /* ---- PRODUCT DATA ---- */
  var productData = [];
  var productDataEl = $('#fss-product-data');
  if (productDataEl) {
    try { productData = JSON.parse(productDataEl.textContent); } catch (e) { console.error('Product data parse error', e); }
  }

  /* ---- DARK MODE ---- */
  var themeToggle = $('#theme-toggle');
  function getTheme() { return localStorage.getItem('fss-theme') || 'light'; }
  function applyTheme(t) {
    document.documentElement.classList.toggle('dark', t === 'dark');
    localStorage.setItem('fss-theme', t);
    var logos = $$('#logo-img, #footer-logo-img');
    logos.forEach(function (img) {
      if (img) img.style.filter = t === 'dark' ? 'invert(1)' : 'none';
    });
    /* Star-up static icon: star_icon.png is black → invert in dark mode so it's white/visible */
    var sbi = document.getElementById('star-btn-img');
    if (sbi) sbi.style.filter = t === 'dark' ? 'invert(1)' : '';
  }
  applyTheme(getTheme());
  function toggleTheme() { applyTheme(getTheme() === 'dark' ? 'light' : 'dark'); }
  if (themeToggle) {
    themeToggle.addEventListener('click', toggleTheme);
  }
  /* Exposed so the in-search-bar nav "Theme" bubble can flip dark mode too. */
  window.fssToggleTheme = toggleTheme;

  /* ---- ADMIN: reveal the "Sell" link in the profile menu for the admin email.
     Re-checks on load, DOM-ready, pageshow, and every time the menu opens, so it
     never gets stuck hidden after a sign-in/out. Client-side gate is UX only. ---- */
  function fssRevealSell() {
    var sell = document.getElementById('starup-sell-link');
    if (!sell) return;
    var u; try { u = JSON.parse(localStorage.getItem('fss_user')); } catch (e) { u = null; }
    sell.style.display = (u && u.email === 'theodorepalsercontact@gmail.com') ? '' : 'none';
  }
  window.fssRevealSell = fssRevealSell;
  fssRevealSell();
  document.addEventListener('DOMContentLoaded', fssRevealSell);
  window.addEventListener('pageshow', fssRevealSell);


  /* ---- MONTHLY PROGRESS BAR — segmented day cells ---- */
  var progressDays = $('#progress-days');
  if (progressDays) {
    var now = new Date();
    var currentDay = now.getDate();
    var daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    var dayProgress = (now.getHours() * 60 + now.getMinutes()) / (24 * 60);

    for (var d = 1; d <= daysInMonth; d++) {
      var cell = document.createElement('div');
      cell.className = 'fss-day-cell';
      var bg = document.createElement('div');
      bg.className = 'fss-day-cell-bg';
      cell.appendChild(bg);

      if (d < currentDay) {
        cell.classList.add('past');
      } else if (d === currentDay) {
        cell.classList.add('current');
        var fill = document.createElement('div');
        fill.className = 'fss-day-cell-fill';
        fill.style.width = (dayProgress * 100) + '%';
        var edge = document.createElement('div');
        edge.className = 'fss-day-cell-edge';
        fill.appendChild(edge);
        cell.appendChild(fill);
      }
      progressDays.appendChild(cell);
    }
  }

  /* ---- SEARCH FOCUS ANIMATION ---- */
  var searchBarEl = $('#search-bar');
  var searchInput = $('#search-input');
  var recentReleasesEl = $('#recent-releases');
  var recentCollapsed = false;
  var recentGridCards = $$('.fss-in-recent');
  function showRecentInGrid(show) {
    recentGridCards.forEach(function (c) {
      if (show) c.classList.remove('fss-in-recent');
      else c.classList.add('fss-in-recent');
    });
  }
  if (searchInput && searchBarEl) {
    /* ORIGINAL search-focus behavior, restored. Adds .focused, collapses the
       "Recently" row into the grid, and on mobile simply re-asserts the scroll
       position once to absorb the browser's focus nudge. No custom
       sticky/anchor re-engineering — that only ever made things worse. */
    searchInput.addEventListener('focus', function () {
      searchBarEl.classList.add('focused');
      if (recentReleasesEl && !recentCollapsed) {
        recentReleasesEl.classList.add('hidden');
        recentCollapsed = true;
        showRecentInGrid(true);
        applyFilters();
      }
      if (window.matchMedia('(max-width: 1023px)').matches) {
        var _sy = window.scrollY;
        requestAnimationFrame(function () { window.scrollTo(0, _sy); });
      }
    });
    searchInput.addEventListener('blur', function () {
      searchBarEl.classList.remove('focused');
    });
  }

  /* ---- HAMBURGER → NAV BUBBLES (emerge from the search bar) ----
     One handler for both the homepage and marketplace search bars. The
     hamburger reveals a row of pill bubbles that slides out just below the
     search input (styled like the category bubbles) instead of replacing the
     input. Clicking outside closes it; the Theme bubble flips light/dark. */
  (function () {
    var bar = searchBarEl;
    if (!bar) return;
    var trigger = bar.querySelector('.fss-menu-trigger');

    /* ---- BOTTOM-SHEET NAV (replaces the in-bar morph) ----
       The ☰ opens an Etsy-style bottom sheet listing the nav destinations, with a
       scrim darkening the rest of the site. */
    var navSheet = document.createElement('div');
    navSheet.className = 'fss-nav-sheet';
    navSheet.setAttribute('hidden', '');
    navSheet.innerHTML =
      '<div class="fss-nav-sheet-grab"></div>' +
      '<button class="fss-nav-sheet-item" data-nav="womens">Women\'s</button>' +
      '<button class="fss-nav-sheet-item" data-nav="mens">Men\'s</button>' +
      '<button class="fss-nav-sheet-item" data-nav="collections">Collections</button>' +
      '<button class="fss-nav-sheet-item" data-nav="marketplace">Marketplace</button>' +
      '<button class="fss-nav-sheet-item" data-nav="sale">Sale</button>' +
      '<button class="fss-nav-sheet-item" data-nav="about">About</button>';
    var navScrim = document.createElement('div');
    navScrim.className = 'fss-nav-sheet-scrim';
    navScrim.setAttribute('hidden', '');
    document.body.appendChild(navScrim);
    document.body.appendChild(navSheet);
    var sheetOpen = false;
    function openSheet() {
      sheetOpen = true;
      navSheet.removeAttribute('hidden'); navScrim.removeAttribute('hidden');
      requestAnimationFrame(function () { navSheet.classList.add('open'); navScrim.classList.add('open'); });
      if (trigger) trigger.classList.add('open');
    }
    function closeSheet() {
      sheetOpen = false;
      navSheet.classList.remove('open'); navScrim.classList.remove('open');
      setTimeout(function () { if (!sheetOpen) { navSheet.setAttribute('hidden', ''); navScrim.setAttribute('hidden', ''); } }, 240);
      if (trigger) trigger.classList.remove('open');
    }
    navScrim.addEventListener('click', closeSheet);
    navSheet.addEventListener('click', function (e) {
      var item = e.target.closest('[data-nav]'); if (!item) return;
      var nav = item.dataset.nav;
      closeSheet();
      if (nav === 'marketplace') { window.location.href = '/marketplace'; return; }
      if (nav === 'about') { window.location.href = '/about'; return; }
      if (nav === 'collections') { if (window.fssOpenCollections) window.fssOpenCollections(); return; }
      if (window.fssSetCategory) window.fssSetCategory(nav); /* womens / mens / sale */
    });
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        sheetOpen ? closeSheet() : openSheet();
      });
    }
    bar.querySelectorAll('.fss-nav-bubble').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (btn.dataset.action === 'close-nav') {
          bar.classList.remove('nav-open');
          if (trigger) trigger.classList.remove('open');
          return;
        }
        if (btn.dataset.action === 'toggle-theme') {
          if (window.fssToggleTheme) window.fssToggleTheme();
          return;
        }
        if (btn.dataset.action === 'open-collections') {
          bar.classList.remove('nav-open');
          if (trigger) trigger.classList.remove('open');
          if (window.fssOpenCollections) window.fssOpenCollections();
          return;
        }
        if (btn.dataset.tag) {
          /* Women's / Men's — filter the current page in place (no navigation). */
          bar.classList.remove('nav-open');
          if (trigger) trigger.classList.remove('open');
          if (window.fssSetCategory) window.fssSetCategory(btn.dataset.tag);
          return;
        }
        if (btn.dataset.url) window.location.href = btn.dataset.url;
      });
    });
    document.addEventListener('click', function (e) {
      if (bar.classList.contains('nav-open') && !bar.contains(e.target)) {
        bar.classList.remove('nav-open');
        if (trigger) trigger.classList.remove('open');
      }
    });
  })();

  /* ---- STAR EXPLOSION ANIMATION ---- */
  var starCanvas = $('#star-canvas');
  var starCtx = starCanvas ? starCanvas.getContext('2d') : null;
  var starParticles = [];
  var starAnimFrame = null;
  var starImage = null;
  var starLoaded = false;

  (function loadStarImage() {
    if (typeof window === 'undefined') return;
    var img = new Image();
    img.onload = function () { starLoaded = true; };
    img.onerror = function () {
      var fallback = new Image();
      fallback.onload = function () { starLoaded = true; starImage = fallback; };
      fallback.src = '/star_icon.png';
    };
    img.src = window.fss && window.fss.starImageUrl ? window.fss.starImageUrl : '/star_icon.png';
    starImage = img;
  })();

  function triggerStarExplosion(x, y, count, size) {
    if (!starCanvas) return;
    if (starCanvas.width !== window.innerWidth || starCanvas.height !== window.innerHeight) {
      starCanvas.width = window.innerWidth;
      starCanvas.height = window.innerHeight;
    }
    for (var i = 0; i < count; i++) {
      starParticles.push({
        x: x,
        y: y,
        width: size,
        height: size,
        velocityX: (Math.random() - 0.5) * 26.25,
        velocityY: Math.random() * -26.25 - 5,
        gravity: 0.8,
        drag: 0.98,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 10
      });
    }
    if (!starAnimFrame) animateStars();
  }

  function animateStars() {
    if (!starCanvas || !starCtx) { starAnimFrame = null; return; }
    starCtx.clearRect(0, 0, starCanvas.width, starCanvas.height);
    var canDraw = !!(starImage && starLoaded);
    var isDarkMode = document.documentElement.classList.contains('dark');

    starParticles = starParticles.filter(function (p) {
      p.velocityY += p.gravity;
      p.velocityX *= p.drag;
      p.x += p.velocityX;
      p.y += p.velocityY;
      p.rotation += p.rotationSpeed;

      if (canDraw) {
        starCtx.save();
        /* star_icon.png is black; invert in dark mode so flying stars are white */
        starCtx.filter = isDarkMode ? 'invert(1)' : 'none';
        starCtx.translate(p.x + p.width / 2, p.y + p.height / 2);
        starCtx.rotate(p.rotation * Math.PI / 180);
        starCtx.drawImage(starImage, -p.width / 2, -p.height / 2, p.width, p.height);
        starCtx.restore();
      }
      var alive = p.y < starCanvas.height + 100;
      /* When a tagged particle leaves the bottom of the screen, fire its exit
         callback once (used by the hover-box explosion to count off-screen
         stars and toggle the circle color). */
      if (!alive && typeof p.onExit === 'function') { p.onExit(); p.onExit = null; }
      return alive;
    });

    if (starParticles.length > 0) {
      starAnimFrame = requestAnimationFrame(animateStars);
    } else {
      starAnimFrame = null;
      starCtx.clearRect(0, 0, starCanvas.width, starCanvas.height);
    }
  }

  // Initial explosion on page load
  setTimeout(function () {
    if (window.innerWidth) {
      triggerStarExplosion(window.innerWidth / 2, window.innerHeight, 5, 50);
    }
  }, 600);

  // Search bar star triggers — once per focus, always fires 1–5 stars from click position
  var searchStarFired = false;
  var searchClickX = 0;
  var searchClickY = 0;
  if (searchInput) {
    searchInput.addEventListener('mousedown', function (e) {
      searchClickX = e.clientX;
      searchClickY = e.clientY;
    });
    searchInput.addEventListener('touchstart', function (e) {
      if (e.touches[0]) { searchClickX = e.touches[0].clientX; searchClickY = e.touches[0].clientY; }
    });
    searchInput.addEventListener('focus', function () {
      if (searchStarFired) return;
      searchStarFired = true;
      var count = Math.floor(Math.random() * 5) + 1;
      if (!searchClickX && !searchClickY) {
        var rect = searchInput.getBoundingClientRect();
        searchClickX = rect.left + rect.width / 2;
        searchClickY = rect.top + rect.height / 2;
      }
      triggerStarExplosion(searchClickX, searchClickY, count, 28);
      searchClickX = 0;
      searchClickY = 0;
    });
    searchInput.addEventListener('blur', function () {
      searchStarFired = false;
    });
  }

  /* ---- SEARCH & FILTER ---- */
  var searchClear = $('#search-clear');
  var tagBubblesContainer = $('#tag-bubbles');
  var tagBubbles = $$('.fss-bubble');
  var productCards = $$('.fss-product-card');
  var marginCards = $$('.fss-margin-card');
  var mobileMarginRow = $('#mobile-margin-row');
  var activeTag = null;
  var activeMid = null;   /* mid-level filter under Silver: 'fine' | 'sterling' */
  var activeSub = null;   /* sub-category filter (e.g. tote-bags, key-dishes, cubes) */
  var activeSize = null;
  var searchQuery = '';

  /* Synonym groups — searching any term in a group matches products tagged with any
     term in that group. Also drives category + sub-category filtering.
     ORDER MATTERS: the specific sub-category groups are listed BEFORE the broad
     parent groups so expandTerm() resolves a sub like "wallets" to just wallets
     (not the whole Accessories group). */
  var synonymGroups = [
    /* Accessories sub-categories */
    ['tote bag', 'tote bags', 'tote', 'tote-bags', 'totebag', 'totebags', 'bag', 'bags'],
    ['wallet', 'wallets'],
    ['key charm', 'key charms', 'key-charms', 'keycharm', 'keycharms', 'charm', 'charms'],
    /* Sterling Silver sub-categories */
    ['badge', 'badges', 'patch', 'patches'],
    /* Ceramics sub-categories */
    ['key dish', 'key dishes', 'key-dishes', 'keydish', 'keydishes', 'dish', 'dishes'],
    ['ash tray', 'ash trays', 'ashtray', 'ashtrays', 'ash-tray', 'ash-trays'],
    ['piggy bank', 'piggy banks', 'piggy-bank', 'piggy-banks', 'piggybank', 'piggybanks', 'piggy'],
    /* Broad parent categories (include their sub-terms so the parent matches all) */
    ['accessories', 'accessory', 'tote bag', 'tote bags', 'tote', 'tote-bags', 'wallet', 'wallets', 'key charm', 'key charms', 'key-charms', 'charm', 'charms', 'bag', 'bags', 'pouch', 'pouches'],
    ['ceramics', 'ceramic', 'key dish', 'key dishes', 'key-dishes', 'dish', 'dishes', 'ash tray', 'ash trays', 'ashtray', 'ashtrays', 'piggy bank', 'piggy banks', 'piggy'],
    ['tshirt', 'tshirts', 't-shirt', 't-shirts', 'tee', 'tees', 'tee shirt', 'tee shirts', 'shirt', 'shirts'],
    ['fine', '.999', '999', 'pure silver', 'investment grade'],
    ['sterling', '.925', '925', 'silver alloy'],
    ['coin', 'coins', 'coinage'],
    ['bar', 'bars', 'ingot', 'ingots'],
    ['round', 'rounds']
  ];

  function expandTerm(term) {
    /* Given a search term (or filter tag), return all synonym variants.
       This lets the user type "tee" and match a product tagged "tshirt". */
    if (!term) return [];
    term = term.toLowerCase().trim();
    if (!term) return [];
    for (var i = 0; i < synonymGroups.length; i++) {
      var group = synonymGroups[i];
      for (var j = 0; j < group.length; j++) {
        if (group[j] === term || term.indexOf(group[j]) !== -1 || group[j].indexOf(term) !== -1) {
          return group;
        }
      }
    }
    return [term];
  }

  function searchMatches(haystack, query) {
    /* Smart text match: query gets expanded to its synonym group, any variant counts as a hit. */
    if (!query) return true;
    var variants = expandTerm(query);
    haystack = haystack.toLowerCase();
    for (var i = 0; i < variants.length; i++) {
      if (haystack.indexOf(variants[i]) !== -1) return true;
    }
    /* Also try sub-tokens of the query (e.g. "large tshirt" → ["large", "tshirt"]) */
    var tokens = query.toLowerCase().trim().split(/\s+/);
    if (tokens.length > 1) {
      var allMatch = true;
      for (var t = 0; t < tokens.length; t++) {
        if (!tokens[t]) continue;
        var tokVariants = expandTerm(tokens[t]);
        var tokenMatch = false;
        for (var v = 0; v < tokVariants.length; v++) {
          if (haystack.indexOf(tokVariants[v]) !== -1) { tokenMatch = true; break; }
        }
        if (!tokenMatch) { allMatch = false; break; }
      }
      if (allMatch) return true;
    }
    return false;
  }

  function tagMatches(productTagsArr, filterTag) {
    /* Check if a product (with its tag list) matches a filter tag, using synonym expansion.
       IMPORTANT: empty strings must never match. `'tshirt'.indexOf('') === 0` would
       otherwise make every empty-tag product match every filter. */
    if (!filterTag) return true;
    var validTags = [];
    for (var k = 0; k < productTagsArr.length; k++) {
      var t = (productTagsArr[k] || '').toLowerCase().trim();
      if (t) validTags.push(t);
    }
    if (validTags.length === 0) return false;
    var variants = expandTerm(filterTag);
    for (var i = 0; i < validTags.length; i++) {
      var pt = validTags[i];
      for (var v = 0; v < variants.length; v++) {
        var variant = variants[v];
        if (!variant) continue;
        if (pt === variant) return true;
        /* Substring matching only counts if BOTH strings are at least 3 chars,
           preventing trivial matches like "s" appearing in everything. */
        if (pt.length >= 3 && variant.length >= 3 &&
            (pt.indexOf(variant) !== -1 || variant.indexOf(pt) !== -1)) {
          return true;
        }
      }
    }
    return false;
  }

  function normalizeSize(s) {
    /* Normalize any size string to its canonical abbreviation (s/m/l/xl/2xl). */
    s = (s || '').toLowerCase().trim();
    return sizeLongToShort[s] || s;
  }
  function sizeMatches(card, size) {
    /* Card has data-product-size (single value) or data-product-sizes (comma-separated).
       Both the card value and the filter value are normalized before comparing, so
       "Medium" in data-product-size will match the "M" filter bubble. */
    if (!size) return true;
    var ps = (card.dataset.productSize || card.dataset.productSizes || '').toLowerCase().trim();
    if (!ps) return false;
    var filterNorm = normalizeSize(size);
    var sizeArr = ps.split(',').map(function (s) { return normalizeSize(s.trim()); });
    return sizeArr.indexOf(filterNorm) !== -1;
  }

  /* Canonical map: abbreviation → all equivalent values (for search haystack expansion) */
  var sizeCanonical = {
    's': ['s', 'small', 'sm'],
    'm': ['m', 'medium', 'med'],
    'l': ['l', 'large', 'lg'],
    'xl': ['xl', 'x-large', 'xlarge', 'extra-large', 'extra large'],
    '2xl': ['2xl', 'xxl', 'xx-large', 'xxlarge', 'extra extra large', '2x-large']
  };
  /* Long-form → canonical abbreviation (for normalizing data-product-size at filter time) */
  var sizeLongToShort = {
    'small': 's', 'sm': 's',
    'medium': 'm', 'med': 'm',
    'large': 'l', 'lg': 'l',
    'x-large': 'xl', 'xlarge': 'xl', 'extra-large': 'xl', 'extra large': 'xl',
    'xx-large': '2xl', 'xxlarge': '2xl', 'xxl': '2xl', 'extra extra large': '2xl', '2x-large': '2xl'
  };

  var sizeAliases = {
    's': 's small sm',
    'm': 'm medium med',
    'l': 'l large lg',
    'xl': 'xl extra-large extra large xlarge',
    'xxl': 'xxl 2xl 2x double-xl extra-extra-large'
  };

  function expandSizesForHaystack(sizeInfo) {
    /* Convert "M" or "S,M,L" to a haystack token list including long forms. */
    if (!sizeInfo) return '';
    return sizeInfo.split(',').map(function (s) {
      s = s.trim().toLowerCase();
      return sizeAliases[s] || s;
    }).join(' ');
  }

  function matchesFilter(card) {
    var tags = (card.dataset.productTags || '').toLowerCase();
    var title = (card.dataset.productTitle || '').toLowerCase();
    var q = searchQuery.trim();
    /* Search: title + tags + size (with long-form expansion) all count as searchable text */
    var sizeInfo = (card.dataset.productSize || card.dataset.productSizes || '').toLowerCase();
    var sizeHaystack = expandSizesForHaystack(sizeInfo);
    var haystack = title + ' ' + tags + ' ' + sizeHaystack;
    if (!searchMatches(haystack, q)) return false;
    /* Hide 'secret' tagged items unless the Secrets filter is explicitly active */
    var _sTags = tags.split(',').map(function (t) { return t.trim(); });
    if (activeTag !== 'secret' && tagMatches(_sTags, 'secret')) return false;
    /* Category tag filter. Two specials:
       - 'sale' filters by the on-sale flag, not a tag.
       - 'silver' is the umbrella for Fine + Sterling, so it matches any of silver/fine/sterling. */
    if (activeTag === 'sale') {
      if ((card.dataset.onSale || 'false') !== 'true') return false;
    } else if (activeTag === 'silver') {
      var tagArrS = tags.split(',').map(function (t) { return t.trim(); });
      if (!(tagMatches(tagArrS, 'silver') || tagMatches(tagArrS, 'fine') || tagMatches(tagArrS, 'sterling'))) return false;
    } else if (activeTag === 'mens' || activeTag === 'womens') {
      /* Gender filter: match products tagged mens/womens, and UNISEX counts for both. */
      var tagArrG = tags.split(',').map(function (t) { return t.trim(); });
      if (!(tagMatches(tagArrG, activeTag) || tagMatches(tagArrG, 'unisex'))) return false;
    } else if (activeTag) {
      var tagArr = tags.split(',').map(function (t) { return t.trim(); });
      if (!tagMatches(tagArr, activeTag)) return false;
    }
    /* Mid-level filter (Fine / Sterling under Silver) */
    if (activeMid) {
      var tagArrM = tags.split(',').map(function (t) { return t.trim(); });
      if (!tagMatches(tagArrM, activeMid)) return false;
    }
    /* Sub-category filter (e.g. Tote Bags under Accessories, Cubes under Fine Silver) */
    if (activeSub) {
      var tagArr2 = tags.split(',').map(function (t) { return t.trim(); });
      if (!tagMatches(tagArr2, activeSub)) return false;
    }
    /* Size filter (only meaningful when t-shirt category active) */
    if (activeSize && !sizeMatches(card, activeSize)) return false;
    /* Weight range filter (silver) — grams and/or troy ounces, both must pass if set. */
    if (weightFilter) {
      var wg = cardWeightGrams(card);
      if (wg == null) return false;
      if (weightFilter.gMin != null && wg < weightFilter.gMin) return false;
      if (weightFilter.gMax != null && wg > weightFilter.gMax) return false;
      var ozt = wg / 31.1035;
      if (weightFilter.ozMin != null && ozt < weightFilter.ozMin) return false;
      if (weightFilter.ozMax != null && ozt > weightFilter.ozMax) return false;
    }
    /* Fabric filters (t-shirts) — tag based. */
    if (fabricFilter.weights.length || fabricFilter.types.length || fabricFilter.colors.length) {
      var ftagArr = tags.split(',').map(function (t) { return t.trim(); });
      var hasAny = function (list) { return list.some(function (v) { return ftagArr.indexOf(v) !== -1 || tags.indexOf(v) !== -1; }); };
      if (fabricFilter.weights.length && !hasAny(fabricFilter.weights)) return false;
      if (fabricFilter.types.length && !hasAny(fabricFilter.types)) return false;
      if (fabricFilter.colors.length && !hasAny(fabricFilter.colors)) return false;
    }
    return true;
  }

  var recentItems = $$('.fss-recent-item:not(.fss-recent-empty)');
  function applyFilters() {
    productCards.forEach(function (card) {
      card.style.display = matchesFilter(card) ? '' : 'none';
    });
    marginCards.forEach(function (card) {
      card.style.display = matchesFilter(card) ? '' : 'none';
    });
    recentItems.forEach(function (item) {
      item.style.display = matchesFilter(item) ? '' : 'none';
    });
    /* The left-margin product tiles are moved inline into #product-grid on mobile
       (see splitMobileGrid) and are filtered above via the productCards loop, so the
       old separate-row show/hide gate is no longer needed. */
    if (searchClear) searchClear.style.display = searchQuery ? '' : 'none';
    if ((searchQuery || activeTag) && recentReleasesEl && !recentCollapsed) {
      recentReleasesEl.classList.add('hidden');
      recentCollapsed = true;
      showRecentInGrid(true);
    }
    // No products found state
    var noProducts = $('#no-products');
    if (noProducts && (searchQuery || activeTag)) {
      var anyVisible = productCards.some(function (c) { return c.style.display !== 'none' && !c.classList.contains('fss-in-recent'); });
      noProducts.style.display = anyVisible ? 'none' : '';
    } else if (noProducts) {
      noProducts.style.display = 'none';
    }
    if (typeof splitMobileGrid === 'function') splitMobileGrid();
  }

  var searchSelectedTag = null;   /* category auto-selected by the typed search */
  function highlightBubbles(query) {
    /* Mark the WHOLE matching category bubble as selected as the user types, and
       ACTUALLY select it (revealing its sub-bubbles) — clicking it again deselects
       and clears the search (see the bubble click handler). */
    var q = (query || '').trim().toLowerCase();
    var matchedBubble = null, matchedCount = 0;
    $$('.fss-bubble-cat').forEach(function (bubble) {
      if (!bubble.dataset.origText) bubble.dataset.origText = bubble.textContent.trim();
      bubble.textContent = bubble.dataset.origText;
      var matched = q.length > 0 && bubble.dataset.origText.toLowerCase().indexOf(q) !== -1;
      bubble.classList.toggle('fss-bubble-matched', matched);
      if (matched) { matchedBubble = bubble; matchedCount++; }
    });
    if (matchedCount === 1 && matchedBubble && activeTag !== matchedBubble.dataset.tag) {
      /* Search selected a category: activate it so its sub-bubbles open. */
      searchSelectedTag = matchedBubble.dataset.tag;
      $$('.fss-bubble-cat').forEach(function (b) { b.classList.remove('active'); });
      activeTag = searchSelectedTag;
      matchedBubble.classList.add('active');
      if (typeof setCategorySubs === 'function') setCategorySubs(activeTag);
      applyFilters();
    } else if (!q && searchSelectedTag) {
      /* Search cleared: drop the auto-selection. */
      if (activeTag === searchSelectedTag) {
        activeTag = null;
        $$('.fss-bubble-cat').forEach(function (b) { b.classList.remove('active'); });
        if (typeof setCategorySubs === 'function') setCategorySubs(null);
        applyFilters();
      }
      searchSelectedTag = null;
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchQuery = this.value;
      applyFilters();
      highlightBubbles(this.value);
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      searchQuery = '';
      if (searchInput) { searchInput.value = ''; searchInput.blur(); }
      searchClear.style.display = 'none';
      applyFilters();
      highlightBubbles('');
    });
  }
  function slideBubbleToFirst(bubble) {
    /* FLIP-style animation: capture starting rect, move bubble to position 0 in the DOM,
       capture ending rect, apply inverted transform, then animate to identity transform. */
    if (!tagBubblesContainer) return;
    var firstChild = tagBubblesContainer.firstElementChild;
    if (firstChild === bubble) return;

    var startRect = bubble.getBoundingClientRect();
    tagBubblesContainer.insertBefore(bubble, firstChild);
    var endRect = bubble.getBoundingClientRect();
    var dx = startRect.left - endRect.left;
    if (Math.abs(dx) < 1) return;

    /* Reset the sticky inner scroll so the moved bubble is visible at the new left edge. */
    if (tagBubblesContainer.scrollLeft !== 0) tagBubblesContainer.scrollLeft = 0;

    /* Apply inverted transform with no transition. */
    bubble.style.transition = 'none';
    bubble.style.transform = 'translateX(' + dx + 'px)';
    /* Double rAF — first frame commits the no-transition state, second frame applies the
       animated change. Single rAF or just forcing layout via offsetHeight isn't reliable
       across all browsers; double rAF is the canonical FLIP pattern. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bubble.style.transition = 'transform 0.45s cubic-bezier(0.2, 0.9, 0.3, 1.05)';
        bubble.style.transform = '';
      });
    });
    setTimeout(function () {
      bubble.style.transition = '';
      bubble.style.transform = '';
    }, 600);
  }

  /* Reveal the sub-bubbles belonging to a selected category (sizes for T-shirts,
     Tote Bags/Wallets/Key Charms for Accessories, etc.). Pass null to collapse
     all sub-bubbles and clear sub/size selections. Driven by a data attribute
     the CSS keys off (data-sub-parent). */
  function setCategorySubs(parentTag) {
    if (!tagBubblesContainer) return;
    var hasSubs = parentTag &&
      $$('.fss-bubble-sub[data-parent="' + parentTag + '"]', tagBubblesContainer).length > 0;
    if (hasSubs) {
      tagBubblesContainer.setAttribute('data-sub-parent', parentTag);
    } else {
      tagBubblesContainer.removeAttribute('data-sub-parent');
    }
    /* Changing (or leaving) a category always clears mid + sub + size selections,
       plus any open Weight/Fabric tool filters. */
    activeMid = null;
    activeSub = null;
    activeSize = null;
    tagBubblesContainer.removeAttribute('data-mid-parent');
    $$('.fss-bubble-sub, .fss-bubble-sub2').forEach(function (b) { b.classList.remove('active'); });
    if (typeof resetToolFilters === 'function') resetToolFilters();
  }

  /* Reveal the sub-categories of an active mid-bubble (Fine / Sterling under Silver).
     Pass null to collapse the deepest level and clear sub selection. */
  function setMidSubs(midTag) {
    if (!tagBubblesContainer) return;
    var hasSubs = midTag &&
      $$('.fss-bubble-sub2[data-parent="' + midTag + '"]', tagBubblesContainer).length > 0;
    if (hasSubs) {
      tagBubblesContainer.setAttribute('data-mid-parent', midTag);
    } else {
      tagBubblesContainer.removeAttribute('data-mid-parent');
    }
    activeSub = null;
    $$('.fss-bubble-sub2').forEach(function (b) { b.classList.remove('active'); });
  }

  tagBubbles.forEach(function (btn) {
    btn.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
    btn.addEventListener('click', function () {
      /* Keep results in view — if the user is scrolled below the grid, snap back up
         so the filtered results start right under the (sticky) search bar. */
      if (window.fssScrollToResults) setTimeout(window.fssScrollToResults, 60);

      /* Weight / Fabric tool bubbles open their filter panel instead of filtering. */
      if (btn.dataset.tool) { toggleToolPanel(btn.dataset.tool); return; }
      var isMid = btn.classList.contains('fss-bubble-mid');           /* Fine / Sterling under Silver */
      var isSub2 = btn.classList.contains('fss-bubble-sub2');         /* deepest silver sub (Cubes, ...) */
      var isSub = btn.classList.contains('fss-bubble-sub') && !isMid; /* size or accessories/ceramics sub */

      if (isMid) {
        /* Mid-bubble (Fine / Sterling): grey selection that also opens a deeper level. */
        var midTag = btn.dataset.tag;
        if (activeMid === midTag) {
          activeMid = null;
          btn.classList.remove('active');
          setMidSubs(null);
        } else {
          $$('.fss-bubble-mid').forEach(function (b) { b.classList.remove('active'); });
          activeMid = midTag;
          btn.classList.add('active');
          setMidSubs(midTag);
        }
        applyFilters();
        return;
      }

      if (isSub || isSub2) {
        /* Sub-bubble (grey selection): a size (T-shirts), an accessories/ceramics sub,
           or a deepest silver sub (Cubes / Coins / Charms / ...). */
        var isSize = btn.classList.contains('fss-bubble-size');
        if (isSize) {
          var size = btn.dataset.size;
          if (activeSize === size) {
            activeSize = null;
            btn.classList.remove('active');
          } else {
            $$('.fss-bubble-size').forEach(function (b) { b.classList.remove('active'); });
            activeSize = size;
            btn.classList.add('active');
          }
        } else {
          var subTag = btn.dataset.tag;
          if (activeSub === subTag) {
            activeSub = null;
            btn.classList.remove('active');
          } else {
            $$('.fss-bubble-sub:not(.fss-bubble-size):not(.fss-bubble-mid), .fss-bubble-sub2').forEach(function (b) { b.classList.remove('active'); });
            activeSub = subTag;
            btn.classList.add('active');
          }
        }
        applyFilters();
        return;
      }

      /* Category bubble (black selection). */
      var tag = btn.dataset.tag;
      if (searchSelectedTag && tag === searchSelectedTag) {
        /* This bubble was selected BY the typed search — clicking it deselects it
           AND clears the search text (instead of opening its sub-bubbles). */
        searchSelectedTag = null;
        searchQuery = '';
        if (searchInput) searchInput.value = '';
        if (searchClear) searchClear.style.display = 'none';
        activeTag = null;
        btn.classList.remove('active', 'fss-bubble-matched');
        setCategorySubs(null);
        applyFilters();
        return;
      }
      if (activeTag === tag) {
        /* Deselect category → collapse its sub-bubbles. */
        activeTag = null;
        btn.classList.remove('active');
        setCategorySubs(null);
      } else {
        tagBubbles.forEach(function (b) {
          if (!b.classList.contains('fss-bubble-sub') && !b.classList.contains('fss-bubble-sub2')) b.classList.remove('active');
        });
        activeTag = tag;
        btn.classList.add('active');
        slideBubbleToFirst(btn);
        setCategorySubs(tag);
      }
      applyFilters();
    });
  });

  /* ---- WEIGHT (silver) / FABRIC (t-shirts) filter panels ---- */
  var weightFilter = null;                                    /* {gMin,gMax,ozMin,ozMax} */
  var fabricFilter = { weights: [], types: [], colors: [] };  /* tag-based tee filters */
  function cardWeightGrams(card) {
    var tags = (card.dataset.productTags || '').split(',');
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].trim().toLowerCase().match(/^([\d.]+)\s*(ozt|grams?|g)$/);
      if (m) { var v = parseFloat(m[1]); return m[2] === 'ozt' ? v * 31.1035 : v; }
    }
    return null;
  }
  function resetToolFilters() {
    weightFilter = null;
    fabricFilter = { weights: [], types: [], colors: [] };
    if (toolPanel) { toolPanel.style.display = 'none'; toolOpenName = null; }
  }
  var toolPanel = document.createElement('div');
  toolPanel.className = 'fss-tool-panel';
  toolPanel.style.display = 'none';
  if (tagBubblesContainer && tagBubblesContainer.parentNode) tagBubblesContainer.parentNode.appendChild(toolPanel);
  var toolOpenName = null;
  function teeColors() {
    var COLORS = ['white', 'black', 'grey', 'gray', 'blue', 'red', 'green', 'pink', 'orange', 'purple', 'yellow', 'brown', 'tan', 'cream', 'navy', 'off-white'];
    var found = {};
    (productData || []).forEach(function (p) {
      var t = (p.tags || []).map(function (x) { return String(x).toLowerCase().trim(); });
      var isTee = t.indexOf('tshirt') !== -1 || t.indexOf('t-shirt') !== -1 || t.indexOf('tshirts') !== -1;
      if (!isTee) return;
      t.forEach(function (x) { if (COLORS.indexOf(x) !== -1) found[x] = 1; });
    });
    return Object.keys(found);
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function renderToolPanel(tool) {
    if (tool === 'weight') {
      var wf = weightFilter || {};
      toolPanel.innerHTML =
        '<div class="fss-tool-row"><span class="fss-tool-label">Grams:</span>' +
          '<input type="number" inputmode="decimal" class="fss-tool-num" id="fss-w-gmin" placeholder="min" value="' + (wf.gMin != null ? wf.gMin : '') + '">' +
          '<span class="fss-tool-dash">–</span>' +
          '<input type="number" inputmode="decimal" class="fss-tool-num" id="fss-w-gmax" placeholder="max" value="' + (wf.gMax != null ? wf.gMax : '') + '"></div>' +
        '<div class="fss-tool-row"><span class="fss-tool-label">Troy Ounces:</span>' +
          '<input type="number" inputmode="decimal" class="fss-tool-num" id="fss-w-ozmin" placeholder="min" value="' + (wf.ozMin != null ? wf.ozMin : '') + '">' +
          '<span class="fss-tool-dash">–</span>' +
          '<input type="number" inputmode="decimal" class="fss-tool-num" id="fss-w-ozmax" placeholder="max" value="' + (wf.ozMax != null ? wf.ozMax : '') + '"></div>' +
        '<div class="fss-tool-row"><button class="fss-bubble fss-tool-apply" id="fss-w-apply">Apply</button>' +
        '<button class="fss-bubble fss-tool-clear" id="fss-w-clear">Clear</button></div>';
    } else {
      var mk = function (list, val, kind) {
        var on = list.indexOf(val) !== -1;
        return '<button class="fss-bubble fss-tool-opt' + (on ? ' active' : '') + '" data-fkind="' + kind + '" data-fval="' + val + '">' + cap(val) + '</button>';
      };
      toolPanel.innerHTML =
        '<div class="fss-tool-row"><span class="fss-tool-label">Fabric Weights:</span>' +
          mk(fabricFilter.weights, '6.5 oz', 'weights') + mk(fabricFilter.weights, '8.5 oz', 'weights') + '</div>' +
        '<div class="fss-tool-row"><span class="fss-tool-label">Fabric Types:</span>' +
          mk(fabricFilter.types, 'mineral wash', 'types') + '</div>' +
        '<div class="fss-tool-row"><span class="fss-tool-label">Color:</span>' +
          teeColors().map(function (c) { return mk(fabricFilter.colors, c, 'colors'); }).join('') + '</div>';
    }
  }
  function toggleToolPanel(tool) {
    if (toolOpenName === tool) { toolPanel.style.display = 'none'; toolOpenName = null; return; }
    toolOpenName = tool;
    renderToolPanel(tool);
    toolPanel.style.display = '';
  }
  toolPanel.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-fkind]');
    if (opt) {
      var list = fabricFilter[opt.dataset.fkind];
      var idx = list.indexOf(opt.dataset.fval);
      idx === -1 ? list.push(opt.dataset.fval) : list.splice(idx, 1);
      opt.classList.toggle('active', idx === -1);
      applyFilters();
      return;
    }
    if (e.target.id === 'fss-w-apply') {
      var num = function (id) { var v = document.getElementById(id).value.trim(); return v === '' ? null : parseFloat(v); };
      weightFilter = { gMin: num('fss-w-gmin'), gMax: num('fss-w-gmax'), ozMin: num('fss-w-ozmin'), ozMax: num('fss-w-ozmax') };
      if (weightFilter.gMin == null && weightFilter.gMax == null && weightFilter.ozMin == null && weightFilter.ozMax == null) weightFilter = null;
      applyFilters();
    } else if (e.target.id === 'fss-w-clear') {
      weightFilter = null;
      renderToolPanel('weight');
      applyFilters();
    }
  });
  /* Weight… / Fabric… entries inside the FILTER menu too. */
  (function () {
    var sm = document.getElementById('sort-menu');
    if (!sm) return;
    [['weight', 'Weight…'], ['fabric', 'Fabric…']].forEach(function (pair) {
      var b = document.createElement('button');
      b.className = 'fss-sort-option';
      b.textContent = pair[1];
      b.addEventListener('click', function (e) { e.stopPropagation(); sm.style.display = 'none'; toggleToolPanel(pair[0]); });
      sm.appendChild(b);
    });
  })();

  /* After a search / filter is applied while scrolled down, bring the user back up so
     the results start right below the (sticky) search bar instead of stranding them
     near the bottom of the page. */
  window.fssScrollToResults = function () {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var bar = document.getElementById('search-bar');
    var barH = (bar && bar.classList.contains('sticky')) ? bar.offsetHeight : 0;
    var top = grid.getBoundingClientRect().top + window.scrollY - barH - 10;
    if (top < 0) top = 0;
    if (window.scrollY > top) window.scrollTo(0, top);
  };

  /* Programmatic category filter (used by the morphed nav buttons: Women's / Men's). */
  window.fssSetCategory = function (tag) {
    $$('.fss-bubble').forEach(function (b) { b.classList.remove('active'); });
    if (tagBubblesContainer) { tagBubblesContainer.removeAttribute('data-sub-parent'); tagBubblesContainer.removeAttribute('data-mid-parent'); }
    activeMid = null; activeSub = null; activeSize = null;
    activeTag = tag;
    var b = document.querySelector('.fss-bubble-cat[data-tag="' + tag + '"]');
    if (b) { b.classList.add('active'); if (typeof setCategorySubs === 'function') setCategorySubs(tag); }
    applyFilters();
    if (typeof highlightBubbles === 'function') highlightBubbles('');
    if (typeof splitMobileGrid === 'function') splitMobileGrid();
    if (window.fssScrollToResults) setTimeout(window.fssScrollToResults, 60);
  };

  /* ---- COLLECTIONS VIEW — the Collections nav button swaps the product grid for 10
     collection tiles. Tapping one filters the page to that collection. Defaults are
     generic buckets built from the tags in use so far. ---- */
  (function () {
    var COLLECTIONS = [
      { title: 'All Silver', tag: 'silver' },
      { title: 'Fine Silver', tag: 'fine' },
      { title: 'Sterling Silver', tag: 'sterling' },
      { title: 'Silver Coins', tag: 'coins' },
      { title: 'Silver Cubes', tag: 'cubes' },
      { title: 'Silver Rounds', tag: 'rounds' },
      { title: 'Graphic Tees', tag: 'tshirts' },
      { title: 'Accessories', tag: 'accessories' },
      { title: 'Ceramics', tag: 'ceramics' },
      { title: 'On Sale', tag: 'sale' }
    ];
    var mainCol = document.querySelector('.fss-main-col') || document.querySelector('.fss-main-col-full');
    var grid = document.getElementById('product-grid');
    if (!mainCol || !grid) return;
    var hideEls = ['recent-releases', 'mobile-margin-row', 'product-grid', 'product-grid-2col', 'no-products']
      .map(function (id) { return document.getElementById(id); }).filter(Boolean);
    var mpHeader = mainCol.querySelector('.fss-marketplace-header');
    if (mpHeader) hideEls.push(mpHeader);
    var leftCol = document.getElementById('left-col');

    function imgForTag(tag) {
      var p;
      if (tag === '__new') {
        p = productData.slice().sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); })[0];
      } else {
        p = productData.find(function (pd) {
          var t = (pd.tags || []).join(',').toLowerCase();
          if (tag === 'silver') return /silver|fine|sterling/.test(t);
          if (tag === 'sale') return pd.compare_at_price && pd.compare_at_price > pd.price;
          return t.indexOf(tag) !== -1;
        });
      }
      return p ? (p.featured_image || (p.images && p.images[0]) || '') : '';
    }

    var view = document.createElement('div');
    view.className = 'fss-collections-view';
    view.id = 'fss-collections';
    view.style.display = 'none';
    mainCol.insertBefore(view, (document.getElementById('recent-releases') || mpHeader || grid));

    function build() {
      view.innerHTML =
        '<div class="fss-collections-head"><button class="fss-collections-back" type="button">&lsaquo; Back</button><span>Collections</span></div>' +
        '<div class="fss-collections-grid">' +
        COLLECTIONS.map(function (c) {
          var img = imgForTag(c.tag);
          return '<button class="fss-collection-tile" data-ctag="' + c.tag + '">' +
            '<span class="fss-collection-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="fss-collection-title">' + c.title + '</span></button>';
        }).join('') + '</div>';
    }
    var contentGrid = document.getElementById('content-grid');
    function openView() {
      /* Close the search overlay first so it doesn't overlap the collections view. */
      if (window.fssCloseSearchOverlay) window.fssCloseSearchOverlay();
      build();
      hideEls.forEach(function (el) { el.dataset._disp = el.style.display; el.style.display = 'none'; });
      if (leftCol) { leftCol.dataset._disp = leftCol.style.display; leftCol.style.display = 'none'; }
      /* Collapse the 2-col grid to full width so the collection tiles span the page. */
      if (contentGrid) contentGrid.classList.add('fss-collections-mode');
      view.style.display = '';
    }
    function closeView() {
      view.style.display = 'none';
      hideEls.forEach(function (el) { el.style.display = el.dataset._disp || ''; });
      if (leftCol) leftCol.style.display = leftCol.dataset._disp || '';
      if (contentGrid) contentGrid.classList.remove('fss-collections-mode');
    }
    view.addEventListener('click', function (e) {
      if (e.target.closest('.fss-collections-back')) { closeView(); return; }
      var tile = e.target.closest('[data-ctag]');
      if (!tile) return;
      var tag = tile.dataset.ctag;
      closeView();
      if (window.fssSetCategory) window.fssSetCategory(tag === '__new' ? null : tag);
    });
    window.fssOpenCollections = openView;
  })();

  /* ---- STICKY SEARCH ---- */
  var searchSentinel = $('#search-sentinel');
  var searchBar = $('#search-bar');

  /* Relocate the animated star button into the sticky search bar.
     At the top of the page the star lives in the header; once the bar goes
     sticky (scrolled down) we move the SAME element into the bar's profile slot
     so it keeps its full animation (idle jump every 5s, click-burst into 5,
     collapse back). Moved home when the user returns to the top. */
  var starUpWrap = document.querySelector('.fss-starup-wrap');
  var starUpHome = starUpWrap ? starUpWrap.parentNode : null;
  var profileSlot = document.getElementById('search-profile-slot');
  function placeStarUp(inBar) {
    if (!starUpWrap || !profileSlot || !starUpHome) return;
    var target = inBar ? profileSlot : starUpHome;
    if (starUpWrap.parentNode === target) return;
    target.appendChild(starUpWrap);
    if (window.fssStarUpResize) requestAnimationFrame(function () { window.fssStarUpResize(); });
  }

  /* DESKTOP: tiny theme + expand-layout buttons that appear at the top-left/right of the
     sticky search bar (the header versions scroll away, these minis take over). */
  var miniTheme = null, miniExpand = null;
  (function () {
    if (!searchBar) return;
    miniTheme = document.createElement('button');
    miniTheme.className = 'fss-mini-fab fss-mini-theme';
    miniTheme.setAttribute('aria-label', 'Toggle theme');
    miniTheme.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
    miniTheme.addEventListener('click', function () {
      var t = document.getElementById('theme-toggle');
      if (t) t.click(); else if (window.fssToggleTheme) window.fssToggleTheme();
    });
    miniExpand = document.createElement('button');
    miniExpand.className = 'fss-mini-fab fss-mini-expand';
    miniExpand.setAttribute('aria-label', 'Expand layout');
    miniExpand.textContent = '<>';
    miniExpand.addEventListener('click', function () {
      var x = document.getElementById('expand-toggle');
      if (x) x.click();
    });
    document.body.appendChild(miniTheme);
    document.body.appendChild(miniExpand);
  })();

  if (searchSentinel && searchBar) {
    var obs = new IntersectionObserver(function (entries) {
      var stuck = !entries[0].isIntersecting;
      searchBar.classList.toggle('sticky', stuck);
      placeStarUp(stuck);
      if (miniTheme) miniTheme.classList.toggle('show', stuck);
      if (miniExpand) miniExpand.classList.toggle('show', stuck);
    }, { threshold: 0, rootMargin: '0px' });
    obs.observe(searchSentinel);
  }

  /* ---- SEARCH OVERLAY — eBay/Etsy style: opens on focus with a "Continue shopping"
     product row + recent searches; shows suggestions while typing. Fixed panel that
     covers the page (so it never jumps to top or shows the bg), preserving scroll. ---- */
  (function () {
    if (!searchInput || !searchBarEl) return;
    var searchGo = document.getElementById('search-go');
    var isMobile = function () { return window.innerWidth < 1024; };

    function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
    function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    function addRecentSearch(q) {
      q = (q || '').trim(); if (!q) return;
      var arr = lsGet('fss_recent_searches').filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      arr.unshift(q); lsSet('fss_recent_searches', arr.slice(0, 8));
    }
    function pdByHandle(h) { return productData.find(function (p) { return p.handle === h; }); }
    function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    var overlay = document.createElement('div');
    overlay.className = 'fss-search-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="fss-so-bar">' +
        '<button type="button" class="fss-so-back" aria-label="Close search"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg></button>' +
        '<input type="text" class="fss-so-input" placeholder="Search" autocomplete="off" enterkeyhint="search">' +
        '<button type="button" class="fss-so-go" aria-label="Search"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></button>' +
      '</div>' +
      '<div class="fss-so-cats" id="fss-so-cats"></div>' +
      '<div class="fss-search-overlay-inner"><div id="fss-so-continue"></div><div id="fss-so-list"></div></div>';
    document.body.appendChild(overlay);
    var contEl = overlay.querySelector('#fss-so-continue');
    var listEl = overlay.querySelector('#fss-so-list');
    var soInput = overlay.querySelector('.fss-so-input');
    var catsEl = overlay.querySelector('#fss-so-cats');

    /* Mirror the page's top-level category bubbles into the overlay (mobile), so the
       categories still show under the search. Tapping one applies that filter + closes. */
    function fillCats() {
      if (!catsEl) return;
      var cats = Array.prototype.slice.call(document.querySelectorAll('#tag-bubbles .fss-bubble-cat'));
      catsEl.innerHTML = cats.map(function (b) {
        var extra = b.classList.contains('fss-bubble-sale') ? ' fss-bubble-sale' : '';
        return '<button class="fss-bubble fss-bubble-cat' + extra + '" data-cat="' + esc(b.dataset.tag) + '">' + esc(b.textContent.trim()) + '</button>';
      }).join('');
    }
    if (catsEl) catsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat]'); if (!b) return;
      var real = document.querySelector('#tag-bubbles .fss-bubble-cat[data-tag="' + b.dataset.cat + '"]');
      if (real) real.click();
      close();
    });

    /* Dim scrim behind the overlay (the search bar itself is raised above it). */
    var backdrop = document.createElement('div');
    backdrop.className = 'fss-search-backdrop';
    backdrop.setAttribute('hidden', '');
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', function () { close(); searchInput.blur(); });

    function continueProducts() {
      /* Preference: recently viewed → recently uploaded. */
      var viewed = lsGet('fss_recent_viewed').map(pdByHandle).filter(Boolean);
      if (viewed.length) return viewed.slice(0, 12);
      return productData.slice().filter(function (p) { return p.available !== false; })
        .sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); }).slice(0, 12);
    }
    function prodCardHtml(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      return '<button class="fss-so-prod" data-handle="' + esc(p.handle) + '">' +
        '<span class="fss-so-prod-img"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy"></span>' +
        '<span class="fss-so-prod-price">' + money(p.price) + '</span></button>';
    }
    var chevron = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    var glass = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

    function renderDefault() {
      var prods = continueProducts();
      contEl.innerHTML = prods.length
        ? '<div class="fss-so-head">Continue shopping</div><div class="fss-so-prow">' + prods.map(prodCardHtml).join('') + '</div>'
        : '';
      var recents = lsGet('fss_recent_searches');
      listEl.innerHTML = recents.length
        ? '<div class="fss-so-head fss-so-head-line">Recent</div>' + recents.map(function (q) {
            return '<button class="fss-so-row" data-q="' + esc(q) + '"><span class="fss-so-rowtext">' + esc(q) + '</span>' + chevron + '</button>';
          }).join('')
        : '';
    }
    function renderSuggest(q) {
      contEl.innerHTML = '';
      var ql = q.toLowerCase();
      var matches = productData.filter(function (p) {
        return (p.title || '').toLowerCase().indexOf(ql) !== -1 ||
               (p.tags || []).join(' ').toLowerCase().indexOf(ql) !== -1;
      }).slice(0, 8);
      var rows = '<button class="fss-so-row fss-so-row-search" data-q="' + esc(q) + '">' + glass +
        '<span class="fss-so-rowtext">Search “' + esc(q) + '”</span></button>';
      rows += matches.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        return '<button class="fss-so-row fss-so-row-prod" data-handle="' + esc(p.handle) + '">' +
          '<span class="fss-so-row-thumb"><img src="' + esc(img) + '" alt=""></span>' +
          '<span class="fss-so-row-title">' + esc(p.title) + '</span>' +
          '<span class="fss-so-row-price">' + money(p.price) + '</span></button>';
      }).join('');
      listEl.innerHTML = rows;
    }
    function render(q) { q = (q || '').trim(); q ? renderSuggest(q) : renderDefault(); }
    function position() {
      if (isMobile()) { overlay.style.top = overlay.style.left = overlay.style.right = overlay.style.width = ''; return; }
      /* Align the dropdown to the VISIBLE search field box (not the wider #search-bar
         container), and hang it just below the whole bar (input + bubbles). */
      var box = (searchInput.closest('.fss-search-inner') || searchInput).getBoundingClientRect();
      var barBottom = searchBarEl.getBoundingClientRect().bottom;
      overlay.style.top = Math.max(0, barBottom + 8) + 'px';
      overlay.style.left = box.left + 'px';
      overlay.style.width = box.width + 'px';
      overlay.style.right = 'auto';
    }
    function activeInput() { return isMobile() ? soInput : searchInput; }
    function applyQuery(q) {
      searchInput.value = q; searchQuery = q;
      if (typeof applyFilters === 'function') applyFilters();
      if (typeof highlightBubbles === 'function') highlightBubbles(q);
      if (window.fssScrollToResults) setTimeout(window.fssScrollToResults, 60);
    }

    var isOpen = false, lastOpen = 0;
    function open() {
      if (isOpen || searchBarEl.classList.contains('nav-open')) return;
      isOpen = true; lastOpen = Date.now();
      overlay.classList.toggle('fss-so-mobile', isMobile());
      if (isMobile()) fillCats();
      position();
      if (isMobile() && soInput) soInput.value = searchInput.value;
      render(isMobile() ? (soInput ? soInput.value : '') : searchInput.value);
      overlay.removeAttribute('hidden');
      backdrop.removeAttribute('hidden');
      searchBarEl.classList.add('fss-search-raised');
      /* On mobile, focus the overlay's own input SYNCHRONOUSLY inside the tap gesture so
         iOS opens the keyboard on the FIRST tap (a focus() call deferred to rAF is treated
         as programmatic and iOS suppresses the keyboard). Desktop keeps the fade. */
      if (isMobile() && soInput) {
        overlay.classList.add('open'); backdrop.classList.add('open');
        try { soInput.focus({ preventScroll: true }); } catch (e) { try { soInput.focus(); } catch (e2) {} }
      } else {
        requestAnimationFrame(function () { overlay.classList.add('open'); backdrop.classList.add('open'); });
      }
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      overlay.classList.remove('open');
      backdrop.classList.remove('open');
      searchBarEl.classList.remove('fss-search-raised');
      setTimeout(function () {
        if (!isOpen) { overlay.setAttribute('hidden', ''); backdrop.setAttribute('hidden', ''); }
      }, 220);
    }
    window.fssCloseSearchOverlay = close;

    /* Real search input: on desktop, focusing opens the dropdown. On mobile it's just a
       trigger — we block its focus (no keyboard / no scroll-to-top) and open the overlay. */
    /* Mobile: distinguish a TAP (open the search) from a DRAG (the user is scrolling and
       happened to start the touch on the bar — let the page scroll, don't open).
       The input is readonly on mobile so a stray focus never pops the keyboard. */
    function syncReadonly() {
      if (isMobile()) searchInput.setAttribute('readonly', 'readonly');
      else searchInput.removeAttribute('readonly');
    }
    syncReadonly();
    window.addEventListener('resize', syncReadonly);
    var stTouch = null;
    searchInput.addEventListener('touchstart', function (e) {
      if (!isMobile() || !e.touches[0]) return;
      stTouch = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
    }, { passive: true });
    searchInput.addEventListener('touchend', function (e) {
      if (!isMobile() || !stTouch) return;
      var t = e.changedTouches[0];
      var moved = t ? (Math.abs(t.clientX - stTouch.x) + Math.abs(t.clientY - stTouch.y)) : 99;
      var quick = Date.now() - stTouch.t < 600;
      stTouch = null;
      if (moved < 12 && quick) { e.preventDefault(); open(); }
    }, { passive: false });
    searchInput.addEventListener('mousedown', function (e) { if (isMobile()) { e.preventDefault(); open(); } });
    searchInput.addEventListener('focus', function () { if (!isMobile()) open(); });
    searchInput.addEventListener('click', function () { open(); });
    searchInput.addEventListener('input', function () {
      if (isMobile()) return;
      if (!isOpen) open();
      render(this.value);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (isMobile()) return;
      if (e.key === 'Enter') { addRecentSearch(this.value); applyQuery(this.value); close(); this.blur(); }
      else if (e.key === 'Escape') { close(); this.blur(); }
    });

    /* Overlay's own input (used on mobile). */
    if (soInput) {
      soInput.addEventListener('input', function () { applyQuery(this.value); render(this.value); });
      soInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { addRecentSearch(this.value); applyQuery(this.value); close(); soInput.blur(); }
        else if (e.key === 'Escape') { close(); soInput.blur(); }
      });
    }
    var backBtn = overlay.querySelector('.fss-so-back');
    if (backBtn) backBtn.addEventListener('click', function () { close(); });
    var soGo = overlay.querySelector('.fss-so-go');
    if (soGo) soGo.addEventListener('click', function () { addRecentSearch(soInput.value); applyQuery(soInput.value); close(); });

    if (searchGo) searchGo.addEventListener('click', function (e) { e.preventDefault(); open(); });

    overlay.addEventListener('click', function (e) {
      var prod = e.target.closest('[data-handle]');
      if (prod) { close(); if (typeof openProductModal === 'function') openProductModal(prod.dataset.handle); return; }
      var qrow = e.target.closest('[data-q]');
      if (qrow) {
        var q = qrow.dataset.q;
        if (soInput) soInput.value = q;
        applyQuery(q); addRecentSearch(q); close();
      }
    });
    /* Close on any click outside the overlay — including the empty space inside the search
       bar (to the right of the tags), which previously only deselected the field. Only the
       search input itself and the go button keep it open. Ignore the click that opened it. */
    document.addEventListener('click', function (e) {
      if (!isOpen || Date.now() - lastOpen < 350) return;
      if (overlay.contains(e.target)) return;
      if (e.target === searchInput || (searchGo && searchGo.contains(e.target))) return;
      close();
    });
    window.addEventListener('resize', function () { if (isOpen) position(); });
  })();

  /* ---- SORT ---- */
  var sortBtn = $('#sort-btn');
  var sortMenu = $('#sort-menu');
  var sortLabel = $('#sort-label');
  var sortOptions = $$('.fss-sort-option');
  var currentSort = 'default';
  var productGrid = $('#product-grid');

  if (sortBtn && sortMenu) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sortMenu.style.display = sortMenu.style.display === 'none' ? 'block' : 'none';
    });
    document.addEventListener('click', function () { sortMenu.style.display = 'none'; });
  }
  sortOptions.forEach(function (opt) {
    opt.addEventListener('click', function () {
      currentSort = this.dataset.sort;
      sortOptions.forEach(function (o) { o.classList.remove('active'); });
      this.classList.add('active');
      sortMenu.style.display = 'none';
      var labels = { 'default': 'Filter', 'price-asc': 'Lowest', 'price-desc': 'Highest', 'created-desc': 'Recent' };
      if (sortLabel) sortLabel.textContent = labels[currentSort] || 'Filter';
      if (sortBtn) sortBtn.classList.toggle('active', currentSort !== 'default');
      applySorting();
    });
  });

  function applySorting() {
    if (!productGrid) return;
    var g2 = $('#product-grid-2col');
    var cards = Array.from(productGrid.children);
    if (g2) cards = cards.concat(Array.from(g2.children));
    cards.sort(function (a, b) {
      if (currentSort === 'price-asc') return (parseInt(a.dataset.productPrice) || 0) - (parseInt(b.dataset.productPrice) || 0);
      if (currentSort === 'price-desc') return (parseInt(b.dataset.productPrice) || 0) - (parseInt(a.dataset.productPrice) || 0);
      if (currentSort === 'created-desc') return (parseInt(b.dataset.productCreated) || 0) - (parseInt(a.dataset.productCreated) || 0);
      return 0;
    });
    cards.forEach(function (c) { productGrid.appendChild(c); });
    if (typeof splitMobileGrid === 'function') splitMobileGrid();
  }

  /* ---- LEFT NAVIGATION DRAWER ---- */
  (function () {
    var navDrawer = document.getElementById('nav-drawer');
    var navOverlay = document.getElementById('nav-overlay');
    var navClose = document.getElementById('nav-drawer-close');
    var menuTriggers = $$('.fss-menu-trigger');
    if (!navDrawer) return;

    var drawerOpen = false;

    function openNavDrawer() {
      if (drawerOpen) return;
      drawerOpen = true;
      navDrawer.classList.add('open');
      if (navOverlay) navOverlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
      if (typeof window.fssShootStars === 'function') window.fssShootStars();
    }
    function closeNavDrawer() {
      if (!drawerOpen) return;
      drawerOpen = false;
      navDrawer.classList.remove('open');
      if (navOverlay) navOverlay.classList.remove('visible');
      document.body.style.overflow = '';
    }

    window.openNavDrawer = openNavDrawer;
    window.closeNavDrawer = closeNavDrawer;

    menuTriggers.forEach(function (trigger) {
      /* Search-bar hamburgers now reveal the emerge-from-bar nav bubbles
         (wired above), on both the homepage and marketplace — so they no
         longer open the left slide-out drawer. */
      if (trigger.closest('.fss-search-bar')) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        drawerOpen ? closeNavDrawer() : openNavDrawer();
      });
    });
    if (navClose) navClose.addEventListener('click', closeNavDrawer);
    if (navOverlay) navOverlay.addEventListener('click', closeNavDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeNavDrawer();
    });


    /* Wire nav drawer category buttons to filter on the current page */
    $$('.fss-nav-cat-btn', navDrawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = this.dataset.tag;
        var bubble = document.querySelector('.fss-bubble-cat[data-tag="' + tag + '"]');
        if (bubble) {
          bubble.click();
        } else if (typeof activeTag !== 'undefined') {
          activeTag = (activeTag === tag) ? null : tag;
          if (typeof setCategorySubs === 'function') setCategorySubs(activeTag);
          if (typeof applyFilters === 'function') applyFilters();
        }
        closeNavDrawer();
      });
    });

    /* Sub-category expand/collapse within drawer */
    $$('.fss-nav-cat-parent', navDrawer).forEach(function (parentBtn) {
      parentBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var subList = this.nextElementSibling;
        if (subList && subList.classList.contains('fss-nav-sub-list')) {
          var isOpen = subList.classList.toggle('open');
          this.classList.toggle('expanded', isOpen);
        }
      });
    });
  })();

  /* ---- EXPAND / CONTRACT TOGGLE ---- */
  var expandBtn = $('#expand-toggle');
  var contentGrid = $('#content-grid');
  if (expandBtn && contentGrid) {
    var isExpanded = localStorage.getItem('fss-expanded') === 'true';
    if (isExpanded) { contentGrid.classList.add('expanded'); expandBtn.textContent = '><'; expandBtn.title = 'Collapse layout'; }
    expandBtn.addEventListener('click', function () {
      isExpanded = !isExpanded;
      contentGrid.classList.toggle('expanded', isExpanded);
      expandBtn.textContent = isExpanded ? '><' : '<>';
      expandBtn.title = isExpanded ? 'Collapse layout' : 'Expand layout';
      localStorage.setItem('fss-expanded', isExpanded);
    });
  }

  /* ---- CART (AJAX API) ---- */
  var cartState = { items: [], item_count: 0, total_price: 0 };

  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartState = cart; updateCartUI(); if (cb) cb(cart); })
      .catch(function (e) { console.error('Cart fetch error', e); });
  }

  function addToCart(variantId, qty, cb) {
    fetch(window.fss.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { fetchCart(cb); })
      .catch(function (e) { console.error('Add to cart error', e); });
  }

  function changeCartItem(lineIndex, qty, cb) {
    fetch(window.fss.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { fetchCart(cb); })
      .catch(function (e) { console.error('Cart change error', e); });
  }

  function removeCartItem(lineIndex, cb) {
    changeCartItem(lineIndex, 0, cb);
  }

  /* Debounce map for cart drawer +/- rapid clicks.
     Key: line index (int), Value: { timer, targetQty } */
  var cartDebounceMap = {};
  var CART_DEBOUNCE_MS = 320;

  /* Per-product state machine for margin card qty +/- clicks.
     Key: productId (string)
     Value: { qty, vid, timer, inFlight }
     - qty:      current optimistic display qty (always the source of truth for clicks)
     - vid:      variant id
     - timer:    debounce timeout id (null when in-flight)
     - inFlight: true while API call + fetchCart are pending
     Entry exists from first click until server confirms final qty.
     updateCartUI skips any product with an active entry. */
  var marginState = {};
  var MARGIN_DEBOUNCE_MS = 350;

  function getMarginState(prodId, vid) {
    if (marginState[prodId]) return marginState[prodId];
    var si = cartState.items.find(function (i) { return String(i.product_id) === prodId; });
    marginState[prodId] = { qty: si ? si.quantity : 0, vid: vid, timer: null, inFlight: false };
    return marginState[prodId];
  }

  function fireMarginAPI(prodId) {
    var s = marginState[prodId];
    if (!s) return;
    s.timer = null;
    s.inFlight = true;
    var snapQty = s.qty;
    var snapVid = s.vid;
    function onDone() {
      var s2 = marginState[prodId];
      if (!s2) return;
      s2.inFlight = false;
      if (s2.qty !== snapQty) {
        /* qty changed while in-flight — fire another call immediately */
        fireMarginAPI(prodId);
      } else {
        delete marginState[prodId];
      }
    }
    var serverItem = cartState.items.find(function (i) { return String(i.product_id) === prodId; });
    if (snapQty <= 0) {
      if (serverItem) removeCartItem(cartState.items.indexOf(serverItem) + 1, onDone);
      else { delete marginState[prodId]; }
    } else if (!serverItem) {
      addToCart(snapVid, snapQty, onDone);
    } else {
      changeCartItem(cartState.items.indexOf(serverItem) + 1, snapQty, onDone);
    }
  }

  function scheduleMarginAPI(prodId) {
    var s = marginState[prodId];
    if (!s) return;
    if (s.inFlight) return; /* onDone will re-fire if qty changed */
    if (s.timer) clearTimeout(s.timer);
    s.timer = setTimeout(function () { fireMarginAPI(prodId); }, MARGIN_DEBOUNCE_MS);
  }

  /* Immediately update the qty display, +/- button state, and cartState
     for a single drawer line — no API call yet. */
  /* Disable all controls for a cart drawer row while an API call is in-flight.
     spinBtn (optional) gets the visual spinner; others are disabled silently. */
  function lockCartRow(line, spinBtn) {
    var sel = '[data-line="' + line + '"]';
    var minus  = document.querySelector('.fss-qty-minus' + sel);
    var plus   = document.querySelector('.fss-qty-plus' + sel);
    var input  = document.querySelector('.fss-cart-qty-input' + sel);
    var remove = document.querySelector('[data-action="cart-remove"]' + sel);
    [minus, plus, remove].forEach(function (b) { if (b) b.disabled = true; });
    if (input) input.disabled = true;
    if (spinBtn) spinBtn.classList.add('loading');
  }

  function drawerQtyOptimisticUpdate(line, newQty, maxStock) {
    var item = cartState.items[line - 1];
    if (!item) return;
    item.quantity = newQty;
    // Recompute item_count from local state
    cartState.item_count = cartState.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    // Update qty input
    var qtyInput = document.querySelector('.fss-cart-qty-input[data-line="' + line + '"]');
    if (qtyInput) qtyInput.value = newQty;
    // Update cart bar count
    var cbc = $('#cart-bar-count');
    if (cbc) cbc.textContent = cartState.item_count;
    // Disable + if at max
    var plusBtn = document.querySelector('.fss-qty-plus[data-line="' + line + '"]');
    if (plusBtn) plusBtn.disabled = newQty >= maxStock;
  }

  /* Schedule a debounced API call for a drawer line. Cancels any pending
     timer for the same line and schedules a fresh one. */
  function drawerQtyDebounced(line, targetQty) {
    if (cartDebounceMap[line]) clearTimeout(cartDebounceMap[line].timer);
    cartDebounceMap[line] = {
      targetQty: targetQty,
      timer: setTimeout(function () {
        delete cartDebounceMap[line];
        if (targetQty <= 0) removeCartItem(line);
        else changeCartItem(line, targetQty);
      }, CART_DEBOUNCE_MS)
    };
  }

  /* ---- CART UI UPDATE ---- */
  function updateCartUI() {
    var cart = cartState;

    // Floating cart bar
    var cartBar = $('#cart-bar');
    var cartBarCount = $('#cart-bar-count');
    var cartBarTotal = $('#cart-bar-total');
    if (cartBar) cartBar.style.display = cart.item_count > 0 ? '' : 'none';
    if (cartBarCount) cartBarCount.textContent = cart.item_count;
    /* Floating cart bar: mirror the drawer's 50%-off — struck original + discounted
       once 5+ items are in the cart, plain total otherwise. */
    var barDisc = fssCartDiscount(cart);
    if (cartBarTotal) {
      if (barDisc.active) {
        cartBarTotal.classList.add('fss-cart-bar-total-disc');
        cartBarTotal.innerHTML =
          '<span class="fss-cart-bar-total-original">' + formatMoney(barDisc.original) + '</span>' +
          '<span class="fss-cart-bar-total-discount">' + formatMoney(barDisc.discounted) + '</span>';
      } else {
        cartBarTotal.classList.remove('fss-cart-bar-total-disc');
        cartBarTotal.textContent = formatMoney(barDisc.original);
      }
    }

    // Cart drawer
    var drawerItems = $('#cart-drawer-items');
    var drawerFooter = $('#cart-drawer-footer');
    var drawerTotal = $('#cart-drawer-total');
    var cartEmpty = $('#cart-empty');
    var drawerItemCount = $('#cart-drawer-item-count');
    var drawerItemsLabel = $('#cart-drawer-items-label');
    if (drawerItemCount) drawerItemCount.textContent = cart.item_count;
    if (drawerItemsLabel) drawerItemsLabel.textContent = cart.item_count === 1 ? 'Item' : 'Items';

    if (drawerItems) {
      var existingItems = $$('.fss-cart-item', drawerItems);
      existingItems.forEach(function (el) { el.remove(); });
    }
    if (cartEmpty) cartEmpty.style.display = cart.items.length === 0 ? '' : 'none';
    if (drawerFooter) drawerFooter.style.display = cart.items.length > 0 ? '' : 'none';

    /* 50% off display: when cart has 5+ items show original total struck through
       and the discounted total. Shared helper keeps this identical to the cart
       bar and checkout page. */
    /* Subtotal counts ONLY available items (sold-out ones are excluded), then an
       estimated shipping line (US $6.24 / International $18), then a grand total. */
    var availItems = cart.items.filter(function (it) { var pd = productData.find(function (p) { return String(p.id) === String(it.product_id); }); return !(pd && pd.available === false); });
    var availCount = availItems.reduce(function (n, it) { return n + it.quantity; }, 0);
    var availSubtotal = availItems.reduce(function (s, it) { return s + it.final_line_price; }, 0);
    var minQty = (window.fss && window.fss.discountMinQty) || 5;
    var discSub = availCount >= minQty ? Math.round(availSubtotal * 0.5) : availSubtotal;
    var isUS = (navigator.language || '').toLowerCase().indexOf('-us') !== -1 || (Intl.DateTimeFormat().resolvedOptions().timeZone || '').indexOf('America') !== -1;
    var shipCents = availItems.length ? (isUS ? 624 : 1800) : 0;
    var grand = discSub + shipCents;
    window.fssDrawerCheckoutable = availItems.length > 0;
    if (drawerTotal) {
      drawerTotal.classList.remove('fss-cart-totals-col');
      var subCell = (availCount >= minQty)
        ? '<span class="fss-cart-drawer-total-original">' + formatMoney(availSubtotal) + '</span> <span class="fss-cart-drawer-total-discount">' + formatMoney(discSub) + '</span>'
        : formatMoney(availSubtotal);
      drawerTotal.innerHTML =
        '<div class="fss-cart-sumline"><span>Subtotal</span><span>' + subCell + '</span></div>' +
        '<div class="fss-cart-sumline"><span>Shipping (' + (isUS ? 'US' : 'Intl') + ')</span><span>' + formatMoney(shipCents) + '</span></div>' +
        '<div class="fss-cart-sumline fss-cart-sumline-total"><span>Total</span><span>' + formatMoney(grand) + '</span></div>';
    }
    var coBtn0 = document.getElementById('checkout-btn');
    if (coBtn0) { coBtn0.disabled = !window.fssDrawerCheckoutable; coBtn0.classList.toggle('fss-btn-disabled', !window.fssDrawerCheckoutable); coBtn0.title = window.fssDrawerCheckoutable ? '' : 'All items in your cart are sold out'; }

    cart.items.forEach(function (item, idx) {
      if (!drawerItems) return;
      var lineIndex = idx + 1;
      /* Look up product handle so the thumbnail is clickable to open the modal */
      var itemPd = productData.find(function (p) { return String(p.id) === String(item.product_id); });
      var itemHandle = itemPd ? itemPd.handle : '';
      var itemSold = itemPd ? (itemPd.available === false) : false;
      var maxStockDrawer = itemPd ? (itemPd.inventory_quantity || 999) : 999;
      var plusDisabled = (itemSold || item.quantity >= maxStockDrawer) ? ' disabled' : '';
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="" class="fss-cart-item-img' + (itemHandle ? ' fss-cart-item-img-clickable' : '') + '"' +
          (itemHandle ? ' data-action="open-modal" data-handle="' + itemHandle + '" role="button" tabindex="0" style="cursor:pointer;"' : '') + '>'
        : '<div class="fss-cart-item-img" style="background:var(--bg-card-alt);display:flex;align-items:center;justify-content:center;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg></div>';
      var div = document.createElement('div');
      div.className = 'fss-cart-item' + (itemSold ? ' fss-cart-item-sold' : '');
      div.innerHTML =
        imgHtml +
        '<div class="fss-cart-item-info"><div class="fss-cart-item-name"' +
        (itemHandle ? ' data-action="open-modal" data-handle="' + itemHandle + '" role="button" tabindex="0" style="cursor:pointer;"' : '') +
        '>' + item.title + '</div>' +
        (itemSold ? '<div class="fss-cart-item-soldtag">Sold — no longer available</div>' : '') + '</div>' +
        '<div class="fss-cart-item-qty-wrap">' +
        '<button class="fss-qty-btn fss-qty-minus" data-line="' + lineIndex + '" data-action="cart-minus"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
        '<input type="number" class="fss-cart-qty-input" value="' + item.quantity + '" min="1" data-line="' + lineIndex + '" data-action="cart-qty-edit">' +
        '<span class="fss-qty-input-spin" aria-hidden="true"></span>' +
        '<button class="fss-qty-btn fss-qty-plus" data-line="' + lineIndex + '" data-action="cart-plus"' + plusDisabled + '><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
        '</div>' +
        '<div class="fss-cart-item-right">' +
        '<div class="fss-cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<button class="fss-cart-item-remove" data-line="' + lineIndex + '" data-action="cart-remove"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>' +
        '</div>';
      drawerItems.appendChild(div);
    });

    // Update product card badges
    $$('[data-cart-badge]').forEach(function (badge) { badge.style.display = 'none'; });
    cart.items.forEach(function (item) {
      var badges = $$('[data-cart-badge="' + item.product_id + '"]');
      badges.forEach(function (badge) {
        badge.style.display = '';
        var qtyEl = $('[data-cart-badge-qty="' + item.product_id + '"]', badge);
        if (qtyEl) qtyEl.textContent = item.quantity;
      });
      // Highlight card
      $$('[data-product-id="' + item.product_id + '"]').forEach(function (card) { card.classList.add('in-cart'); });
    });
    // Remove highlight for cards not in cart
    var inCartIds = cart.items.map(function (i) { return String(i.product_id); });
    $$('.fss-product-card, .fss-margin-card').forEach(function (card) {
      if (inCartIds.indexOf(card.dataset.productId) === -1) card.classList.remove('in-cart');
    });

    // Margin qty displays — reset all to 0, then set actual quantities
    // Skip products with a pending debounce (their optimistic UI is still in flight)
    $$('[data-qty-display]').forEach(function (el) {
      var pid = el.dataset.qtyDisplay;
      if (marginState[pid]) return; // preserve optimistic qty
      if (el.tagName === 'INPUT') el.value = 0;
      else el.textContent = 0;
    });
    cart.items.forEach(function (item) {
      if (marginState[String(item.product_id)]) return; // preserve optimistic qty
      var qtyDisplays = $$('[data-qty-display="' + item.product_id + '"]');
      qtyDisplays.forEach(function (el) {
        if (el.tagName === 'INPUT') el.value = item.quantity;
        else el.textContent = item.quantity;
      });
    });

    /* Sync margin card + button disabled state and cart badges */
    productData.forEach(function (pd) {
      var cartItem = cart.items.find(function (i) { return String(i.product_id) === String(pd.id); });
      var maxStock = pd.inventory_quantity || 999;
      /* Use optimistic qty from state machine if active, else server qty */
      var ms = marginState[String(pd.id)];
      var cartQty = ms ? ms.qty : (cartItem ? cartItem.quantity : 0);
      /* + button: disabled when cart qty has reached available stock */
      $$('[data-action="qty-plus"][data-product-id="' + pd.id + '"]').forEach(function (btn) {
        btn.disabled = cartQty >= maxStock;
      });
      /* Cart badges */
      if (!ms) {
        $$('[data-cart-badge="' + pd.id + '"]').forEach(function (b) {
          b.style.display = cartQty > 0 ? '' : 'none';
          var qEl = b.querySelector('[data-cart-badge-qty="' + pd.id + '"]');
          if (qEl) qEl.textContent = cartQty;
        });
      }
    });

    /* Sync open modal qty if the modal is currently visible */
    var openModalQtyInput = document.getElementById('modal-qty');
    var openModalAddBtn = document.getElementById('modal-add-btn');
    if (openModalQtyInput && openModalAddBtn) {
      var openVid = parseInt(openModalAddBtn.dataset.variantId || '0');
      if (openVid) {
        var openCartItem = cart.items.find(function (i) { return String(i.variant_id) === String(openVid); });
        var openCartQty = openCartItem ? openCartItem.quantity : 0;
        openModalQtyInput.value = openCartQty > 0 ? openCartQty : 1;
        var openPd = productData.find(function (p) { return String(p.variant_id) === String(openVid); });
        var openMax = openPd ? (openPd.inventory_quantity || 999) : 999;
        var openPlus = document.getElementById('modal-qty-plus');
        var openMinus = document.getElementById('modal-qty-minus');
        if (openPlus) openPlus.disabled = openCartQty >= openMax;
        if (openMinus) openMinus.disabled = openCartQty <= 1;
        /* Update Add/Remove button label */
        if (openCartItem) {
          openModalAddBtn.classList.add('in-cart');
          openModalAddBtn.innerHTML = '<span class="fss-atc-label">View Cart</span>';
          var openQtyCol = document.getElementById('modal-qty-col');
          if (openQtyCol) openQtyCol.style.display = '';
        }
      }
    }

    updateWholesaleCounters(cart.item_count);
  }

  /* ---- WHOLESALE X/N PROGRESS ----
     Updates the wholesale page banner AND the cart-drawer progress from the
     live cart item count. The 50% discount itself is a Shopify automatic
     discount (admin) that triggers at the minimum quantity. */
  function updateWholesaleCounters(count) {
    var banner = $('#wholesale-banner');
    var minQty = banner && banner.dataset.minQty ? parseInt(banner.dataset.minQty, 10) : 5;
    if (!minQty || minQty < 1) minQty = 5;
    var met = count >= minQty;
    var shown = Math.min(count, minQty);
    var pct = Math.min(100, Math.round((count / minQty) * 100));

    /* Page banner */
    if (banner) {
      var pageCount = $('#wholesale-counter');
      var pageLabel = $('#wholesale-label');
      var pageFill = $('#wholesale-bar-fill');
      if (pageCount) pageCount.textContent = shown + '/' + minQty;
      if (pageFill) pageFill.style.width = pct + '%';
      banner.classList.toggle('met', met);
      if (pageLabel) {
        pageLabel.innerHTML = met
          ? '<strong>50% off</strong> wholesale pricing unlocked at checkout!'
          : 'Add ' + (minQty - count) + ' more to unlock <strong>50% off</strong> wholesale pricing';
      }
    }

    /* Cart drawer progress (shown only when at least 1 item is in cart) */
    var cartWrap = $('#cart-wholesale');
    if (cartWrap) {
      cartWrap.style.display = count > 0 ? '' : 'none';
      var cartCount = $('#cart-wholesale-count');
      var cartText = $('#cart-wholesale-text');
      var cartFill = $('#cart-wholesale-fill');
      if (cartCount) cartCount.textContent = shown + '/' + minQty;
      if (cartFill) cartFill.style.width = pct + '%';
      cartWrap.classList.toggle('met', met);
      if (cartText) {
        cartText.textContent = met
          ? '50% off activated!'
          : 'Add ' + (minQty - count) + ' more for 50% off';
      }
    }
  }

  /* ---- CART DRAWER TOGGLE ---- */
  var cartOverlay = $('#cart-overlay');
  var cartDrawer = $('#cart-drawer');
  var cartDrawerClose = $('#cart-drawer-close');

  function openCartDrawer() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  var cartDrawerBack = $('#cart-drawer-back');
  if (cartDrawerBack) cartDrawerBack.addEventListener('click', closeCartDrawer);

  /* Cart drawer: swipe right to close on mobile */
  if (cartDrawer) {
    var cdTouchStartX = 0, cdTouchStartY = 0, cdSwipeDecided = false, cdSwipingRight = false;
    cartDrawer.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      cdTouchStartX = e.touches[0].clientX;
      cdTouchStartY = e.touches[0].clientY;
      cdSwipeDecided = false;
      cdSwipingRight = false;
    }, { passive: true });
    cartDrawer.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || cdSwipeDecided) return;
      var dx = e.touches[0].clientX - cdTouchStartX;
      var dy = e.touches[0].clientY - cdTouchStartY;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
        cdSwipeDecided = true;
        cdSwipingRight = (dx > 0 && Math.abs(dx) > Math.abs(dy));
      }
      if (cdSwipingRight) e.preventDefault();
    }, { passive: false });
    cartDrawer.addEventListener('touchend', function (e) {
      if (!cdSwipingRight) return;
      var dx = e.changedTouches[0].clientX - cdTouchStartX;
      if (dx > 60) closeCartDrawer();
      cdSwipingRight = false;
    }, { passive: true });
  }

  // Floating cart bar opens drawer
  var cartBarInner = $('#cart-bar-inner');
  if (cartBarInner) cartBarInner.addEventListener('click', openCartDrawer);

  // Checkout button — go to Shopify's native checkout on the store domain
  // (fivestarsilver.com), the same on desktop and mobile. When the cart has 5+
  // items and a discount CODE is configured, route through Shopify's discount
  // link so the 50% off is actually applied server-side at checkout. If no code
  // is set, we go straight to checkout and any Shopify AUTOMATIC discount applies.
  var checkoutBtn = $('#checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      /* Block checkout if every item in the cart is sold out */
      if (window.fssDrawerCheckoutable === false) { return; }
      var base = (window.fss && window.fss.checkoutUrl) || '/checkout';
      var code = (window.fss && window.fss.discountCode) || '';
      var disc = fssCartDiscount(cartState);
      if (disc.active && code) {
        window.location.href = '/discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(base);
      } else {
        window.location.href = base;
      }
    });
  }

  /* ---- MAKE OFFER MODAL ---- */
  (function () {
    var overlay = document.getElementById('fss-offer-overlay');
    if (!overlay) return;
    var currentVid, currentFullPrice;

    function closeSvg() {
      return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    }

    window.openOfferModal = function (productTitle, priceInCents, vid, imgSrc, variantTitle, rec15dollars) {
      currentVid = vid;
      currentFullPrice = priceInCents;
      var dollars = priceInCents / 100;
      var p10 = (dollars * 0.90).toFixed(2);
      var p15 = (dollars * 0.85).toFixed(2);
      var p20 = (dollars * 0.80).toFixed(2);
      var isMob = window.innerWidth < 768;
      var prefillVal = rec15dollars || parseFloat(p15);
      var imgHtml = imgSrc
        ? '<img class="fss-offer-thumb" src="' + imgSrc + '" alt="">'
        : '<div class="fss-offer-thumb"></div>';

      overlay.querySelector('.fss-offer-box').innerHTML =
        '<div class="fss-offer-header">' +
          '<span class="fss-offer-header-title">Make an offer</span>' +
          '<button class="fss-offer-close-btn" id="fss-offer-close">' + closeSvg() + '</button>' +
        '</div>' +
        '<div class="fss-offer-product-row">' +
          imgHtml +
          '<div class="fss-offer-product-info">' +
            (variantTitle ? '<span class="fss-offer-product-variant">' + variantTitle + '</span>' : '') +
            '<span class="fss-offer-product-price">Current price: $' + dollars.toFixed(2) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="fss-offer-body">' +
          '<div class="fss-offer-input-label">Your offer</div>' +
          '<div class="fss-offer-input-row">' +
            '<span class="fss-offer-currency">$</span>' +
            '<input class="fss-offer-input" id="fss-offer-input" type="number" min="0" step="0.01" placeholder="' + dollars.toFixed(2) + '" value="' + prefillVal.toFixed(2) + '">' +
          '</div>' +
          '<div class="fss-offer-accept-hint" id="fss-offer-hint"><span>&#x25A3;</span> Seller likely to accept $' + prefillVal.toFixed(2) + '</div>' +
          (isMob ? '' : '<div class="fss-offer-presets">' +
            '<button class="fss-offer-preset" data-val="' + p20 + '"><span class="fss-offer-preset-pct">20% Off</span><span class="fss-offer-preset-price">$' + p20 + '</span></button>' +
            '<button class="fss-offer-preset recommended" data-val="' + p15 + '"><span class="fss-offer-preset-pct">15% Off</span><span class="fss-offer-preset-price">$' + p15 + '</span><span class="fss-offer-preset-rec">(Recommended)</span></button>' +
            '<button class="fss-offer-preset" data-val="' + p10 + '"><span class="fss-offer-preset-pct">10% Off</span><span class="fss-offer-preset-price">$' + p10 + '</span></button>' +
          '</div>') +
          '<p class="fss-offer-status" id="fss-offer-status"></p>' +
          '<button class="fss-offer-submit" id="fss-offer-submit">Send offer</button>' +
          '<p class="fss-offer-disclaimer">Offers cannot be combined with the 5-item 50% discount — one or the other applies.</p>' +
        '</div>';

      var inputEl  = overlay.querySelector('#fss-offer-input');
      var statusEl = overlay.querySelector('#fss-offer-status');
      var submitBtn = overlay.querySelector('#fss-offer-submit');

      function updateReady() {
        var v = parseFloat(inputEl.value);
        submitBtn.classList.toggle('ready', v > 0);
      }
      inputEl.addEventListener('input', updateReady);
      /* Auto-select input text on click/focus so user can type immediately */
      inputEl.addEventListener('focus', function () { this.select(); });
      inputEl.addEventListener('click', function () { this.select(); });

      overlay.querySelectorAll('.fss-offer-preset').forEach(function (btn) {
        btn.addEventListener('click', function () {
          /* Deselect all presets, mark this one selected */
          overlay.querySelectorAll('.fss-offer-preset').forEach(function (b) {
            b.classList.remove('selected');
          });
          this.classList.add('selected');
          inputEl.value = this.dataset.val;
          updateReady();
        });
      });

      overlay.querySelector('#fss-offer-close').addEventListener('click', function () {
        overlay.setAttribute('hidden', '');
      });

      submitBtn.addEventListener('click', function () {
        var offerDollars = parseFloat(inputEl.value);
        if (!offerDollars || offerDollars <= 0) {
          statusEl.textContent = 'Please enter a valid offer.';
          statusEl.className = 'fss-offer-status error';
          return;
        }
        var minAccepted = (currentFullPrice / 100) * 0.5;
        if (offerDollars < minAccepted) {
          statusEl.textContent = 'Minimum offer is $' + minAccepted.toFixed(2) + ' (50% of price).';
          statusEl.className = 'fss-offer-status error';
          return;
        }
        submitBtn.disabled = true;
        statusEl.className = 'fss-offer-status';
        statusEl.textContent = 'Sending...';
        fetch('/apps/proxy/offers', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            variant_id: currentVid,
            offer_amount_cents: Math.round(offerDollars * 100),
            full_price_cents: currentFullPrice
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.accepted) {
            statusEl.textContent = 'Offer accepted! Adding to cart...';
            statusEl.className = 'fss-offer-status success';
            addToCart(parseInt(currentVid), 1, function () { openCartDrawer(); });
            setTimeout(function () { overlay.setAttribute('hidden', ''); }, 2000);
          } else if (data.pending) {
            statusEl.textContent = 'Offer sent! You\'ll hear back within 1–3 minutes.';
            statusEl.className = 'fss-offer-status success';
          } else {
            statusEl.textContent = data.message || 'Offer declined.';
            statusEl.className = 'fss-offer-status error';
          }
          submitBtn.disabled = false;
        })
        .catch(function () {
          statusEl.textContent = 'Error sending offer. Try again.';
          statusEl.className = 'fss-offer-status error';
          submitBtn.disabled = false;
        });
      });

      overlay.removeAttribute('hidden');
    };

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.setAttribute('hidden', '');
    });
  }());


  /* ---- DELEGATED CLICK HANDLERS ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;

    // Margin qty buttons
    if (action === 'qty-plus') {
      var vid = parseInt(btn.dataset.variantId);
      var prodId = btn.dataset.productId;
      var pd = productData.find(function (p) { return String(p.id) === prodId || String(p.variant_id) === String(vid); });
      var maxStock = pd ? (pd.inventory_quantity || 999) : 999;
      var s = getMarginState(prodId, vid);
      if (s.qty >= maxStock) return;
      s.qty += 1;
      s.vid = vid;
      /* Optimistic UI update */
      $$('[data-qty-display="' + prodId + '"]').forEach(function (el) {
        if (el.tagName === 'INPUT') el.value = s.qty; else el.textContent = s.qty;
      });
      $$('[data-cart-badge="' + prodId + '"]').forEach(function (b) {
        b.style.display = '';
        var q = $('[data-cart-badge-qty="' + prodId + '"]', b); if (q) q.textContent = s.qty;
      });
      $$('[data-action="qty-plus"][data-product-id="' + prodId + '"]').forEach(function (b) {
        b.disabled = s.qty >= maxStock;
      });
      triggerStarExplosion(e.clientX, e.clientY, 1, 28);
      scheduleMarginAPI(prodId);
    }
    if (action === 'qty-minus') {
      var prodId = btn.dataset.productId;
      var vid2 = btn.dataset.variantId ? parseInt(btn.dataset.variantId) : 0;
      var s2 = getMarginState(prodId, vid2 || undefined);
      if (s2.qty <= 0) return;
      s2.qty -= 1;
      /* Optimistic UI update */
      $$('[data-qty-display="' + prodId + '"]').forEach(function (el) {
        if (el.tagName === 'INPUT') el.value = s2.qty; else el.textContent = s2.qty;
      });
      if (s2.qty <= 0) {
        $$('[data-cart-badge="' + prodId + '"]').forEach(function (b) { b.style.display = 'none'; });
      }
      scheduleMarginAPI(prodId);
    }

    // Cart drawer qty
    if (action === 'cart-minus') {
      var line = parseInt(btn.dataset.line);
      var cartItem = cartState.items[line - 1];
      if (cartItem) {
        if (cartItem.quantity <= 1) {
          // Remove immediately — no debounce needed, item disappears from UI
          cartState.items.splice(line - 1, 1);
          cartState.item_count = cartState.items.reduce(function (s, i) { return s + i.quantity; }, 0);
          updateCartUI();
          removeCartItem(line);
        } else {
          var pd3 = productData.find(function (p) { return String(p.id) === String(cartItem.product_id); });
          var maxStock3 = pd3 ? (pd3.inventory_quantity || 999) : 999;
          var newQ3 = cartItem.quantity - 1;
          drawerQtyOptimisticUpdate(line, newQ3, maxStock3);
          drawerQtyDebounced(line, newQ3);
          lockCartRow(line, btn); // spinner on minus, disable +/input/trash
        }
      }
    }
    if (action === 'cart-plus') {
      var line2 = parseInt(btn.dataset.line);
      var cartItem2 = cartState.items[line2 - 1];
      if (cartItem2) {
        var pd2 = productData.find(function (p) { return String(p.id) === String(cartItem2.product_id); });
        var maxStock2 = pd2 ? (pd2.inventory_quantity || 999) : 999;
        if (cartItem2.quantity >= maxStock2) return;
        var newQ2 = cartItem2.quantity + 1;
        drawerQtyOptimisticUpdate(line2, newQ2, maxStock2);
        drawerQtyDebounced(line2, newQ2);
        lockCartRow(line2, btn); // spinner on plus, disable -/input/trash
        triggerStarExplosion(e.clientX, e.clientY, 1, 28);
      }
    }
    if (action === 'cart-remove') {
      var removeLine = parseInt(btn.dataset.line);
      lockCartRow(removeLine, btn); // spinner on the trash button itself
      removeCartItem(removeLine);
    }
    if (action === 'cart-qty-edit') return;

    // Open product modal
    if (action === 'open-modal') {
      var handle = btn.dataset.handle;
      if (handle) {
        openProductModal(handle);
      }
    }
  });

  // Margin qty input — direct typing
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('fss-margin-qty-input')) return;
    var vid = parseInt(input.dataset.variantId);
    var prodId = input.dataset.productId;
    var newQty = Math.max(0, parseInt(input.value) || 0);
    var existingItem = cartState.items.find(function (i) { return String(i.product_id) === prodId; });

    if (newQty === 0 && existingItem) {
      var lineIdx = cartState.items.indexOf(existingItem) + 1;
      removeCartItem(lineIdx);
    } else if (newQty > 0 && existingItem) {
      var lineIdx2 = cartState.items.indexOf(existingItem) + 1;
      changeCartItem(lineIdx2, newQty);
    } else if (newQty > 0 && !existingItem) {
      addToCart(vid, newQty);
    }
  });
  // Cart drawer qty input — direct typing
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('fss-cart-qty-input')) return;
    var line = parseInt(input.dataset.line);
    var newQty = Math.max(0, parseInt(input.value) || 0);
    lockCartRow(line, null); // disable all controls silently while API call runs
    var wrap = input.closest('.fss-cart-item-qty-wrap');
    if (wrap) wrap.classList.add('loading'); // spinner overlaid on the input number
    if (newQty === 0) removeCartItem(line);
    else changeCartItem(line, newQty);
  });

  // Select all on focus
  document.addEventListener('focus', function (e) {
    if (e.target.classList && (e.target.classList.contains('fss-margin-qty-input') || e.target.classList.contains('fss-cart-qty-input'))) {
      e.target.select();
    }
  }, true);

  /* ---- PRODUCT MODAL ---- */
  var modalOverlay = $('#product-modal-overlay');
  var modalBody = $('#modal-body');
  var modalClose = $('#modal-close');
  /* Session flag: once the user shakes/clicks to enable zoom on any image,
     every subsequent image auto-zooms on hover (no need to shake again). */
  var zoomUnlocked = false;

  /* Desktop: forward wheel scrolling from ANYWHERE on screen while the modal
     is open — the right-hand info side AND the grey backdrop around the modal —
     to the left image column, so the user can scroll the product photos without
     hovering directly over them. Bound to the full-viewport overlay so even the
     grey area counts. Re-queries the current image column each time. */
  if (modalOverlay) {
    modalOverlay.addEventListener('wheel', function (e) {
      if (!window.matchMedia('(min-width: 768px)').matches) return;
      if (modalOverlay.style.display === 'none') return; /* modal closed */
      var imgs = modalOverlay.querySelector('.fss-modal-images');
      if (!imgs || imgs.scrollHeight <= imgs.clientHeight) return;
      /* Let native scroll handle regions we don't want to hijack. */
      if (e.target.closest) {
        if (e.target.closest('.fss-modal-images')) return; /* native */
        var expanded = e.target.closest('.fss-modal-desc.expanded');
        if (expanded && expanded.scrollHeight > expanded.clientHeight) return;
      }
      imgs.scrollTop += e.deltaY;
      e.preventDefault();
    }, { passive: false });
  }

  function openProductModal(handle) {
    var pd = productData.find(function (p) { return p.handle === handle; });
    if (!pd || !modalBody || !modalOverlay) return;

    /* Track recently-viewed for the search overlay's "Continue shopping" row. */
    try {
      var rv = JSON.parse(localStorage.getItem('fss_recent_viewed') || '[]');
      rv = rv.filter(function (h) { return h !== handle; });
      rv.unshift(handle);
      localStorage.setItem('fss_recent_viewed', JSON.stringify(rv.slice(0, 20)));
    } catch (e) {}

    var imagesHtml = '';
    /* A product with only ONE image renders oddly, so show that image twice
       (looks like a 2-image gallery). Real 2+ images are shown as-is. */
    var imgs = (pd.images && pd.images.length === 1) ? [pd.images[0], pd.images[0]] : (pd.images || []);
    if (imgs.length > 0) {
      var allImgs = imgs.map(function (src, idx) {
        return '<div class="fss-modal-img-wrap" data-wrap="' + idx + '">' +
          '<div class="fss-modal-img-glass" id="modal-glass-' + idx + '"></div>' +
          '<img src="' + src + '" alt="' + pd.title + '" class="fss-modal-img" data-slide="' + idx + '">' +
          '</div>';
      }).join('');
      var dots = '';
      if (imgs.length > 1) {
        dots = '<div class="fss-modal-dots">' + imgs.map(function (_, idx) {
          return '<button class="fss-modal-dot' + (idx === 0 ? ' active' : '') + '" data-dot="' + idx + '"></button>';
        }).join('') + '</div>';
      }
      imagesHtml = '<div class="fss-modal-images"><div class="fss-modal-slides" id="modal-slides">' + allImgs + '</div>' + dots + '</div>';
    }

    /* Normalize a raw product tag (e.g. "tshirt", "t-shirt", "sterling") into
       the canonical display label. Synonyms collapse to the same label so they
       can be deduped. Tags not in the map keep their original casing but get
       title-cased as a fallback. */
    function normalizeTagLabel(tag) {
      var t = String(tag || '').toLowerCase().trim();
      var aliases = {
        'tshirt': 'T-Shirt', 't-shirt': 'T-Shirt', 'tshirts': 'T-Shirt',
        't-shirts': 'T-Shirt', 'tee': 'T-Shirt', 'tees': 'T-Shirt',
        'sterling': 'Sterling .925', '.925': 'Sterling .925', '925': 'Sterling .925',
        'sterling silver': 'Sterling .925',
        'fine': 'Fine .999', '.999': 'Fine .999', '999': 'Fine .999',
        'fine silver': 'Fine .999',
        'accessories': 'Accessories', 'accessory': 'Accessories',
        'bag': 'Accessories', 'bags': 'Accessories', 'pouch': 'Accessories',
        'tote-bags': 'Tote Bag', 'tote bag': 'Tote Bag', 'tote bags': 'Tote Bag', 'tote': 'Tote Bag',
        'wallet': 'Wallet', 'wallets': 'Wallet',
        'key-charms': 'Key Charm', 'key charm': 'Key Charm', 'key charms': 'Key Charm', 'charm': 'Key Charm', 'charms': 'Key Charm',
        'ceramics': 'Ceramics', 'ceramic': 'Ceramics',
        'key-dishes': 'Key Dish', 'key dish': 'Key Dish', 'key dishes': 'Key Dish',
        'ash-trays': 'Ash Tray', 'ash tray': 'Ash Tray', 'ash trays': 'Ash Tray', 'ashtray': 'Ash Tray', 'ashtrays': 'Ash Tray',
        'piggy-banks': 'Piggy Bank', 'piggy bank': 'Piggy Bank', 'piggy banks': 'Piggy Bank', 'piggy': 'Piggy Bank',
        'coin': 'Coin', 'coins': 'Coin',
        'bar': 'Bar', 'bars': 'Bar',
        'round': 'Round', 'rounds': 'Round'
      };
      if (aliases[t]) return aliases[t];
      /* Title case fallback for unknown tags */
      return tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase();
    }
    /* Size-like tags are shown separately as the silver size badge, so skip
       them here to avoid a duplicate junk bubble (e.g. a bare "small"/"l" tag). */
    var sizeTagSkip = {
      's': 1, 'm': 1, 'l': 1, 'xl': 1, 'xxl': 1, '2xl': 1,
      'small': 1, 'medium': 1, 'med': 1, 'large': 1, 'lg': 1,
      'x-large': 1, 'extra large': 1, 'extra-large': 1, 'xlarge': 1,
      'xx-large': 1, 'extra extra large': 1
    };
    function dedupeAndNormalizeTags(tags) {
      var seen = {};
      var out = [];
      (tags || []).forEach(function (t) {
        if (!t) return;
        var raw = String(t).toLowerCase().trim();
        if (sizeTagSkip[raw]) return;
        if (raw.indexOf('size-') === 0 || raw.indexOf('size:') === 0) return;
        var label = normalizeTagLabel(t);
        var key = label.toLowerCase();
        if (!seen[key]) { seen[key] = true; out.push(label); }
      });
      return out;
    }
    function sizeLabelLong(s) {
      var map = { 's': 'Small', 'm': 'Medium', 'l': 'Large', 'xl': 'XL', 'xxl': 'XXL' };
      var k = String(s || '').toLowerCase().trim();
      return map[k] || s;
    }

    /* Pull size from the rendered product card's data attribute. Avoids
       duplicating the multi-path Liquid size-resolution logic in JS. */
    var sourceCard = document.querySelector(
      '.fss-product-card[data-product-handle="' + pd.handle + '"], ' +
      '.fss-margin-card[data-product-handle="' + pd.handle + '"]'
    );
    var productSize = sourceCard ? (sourceCard.dataset.productSize || '') : '';

    var tagBubblesHtml = '';
    if (productSize) {
      tagBubblesHtml += '<span class="fss-modal-tag fss-modal-tag-size">' +
        sizeLabelLong(productSize) + '</span>';
    }
    /* 100% Cotton badge — shown for any t-shirt product */
    var _tagsLower = (pd.tags || []).join(' ').toLowerCase();
    var _typeL = (pd.type || '').toLowerCase();
    var _isTshirt = _tagsLower.indexOf('tshirt') !== -1 || _tagsLower.indexOf('t-shirt') !== -1 ||
                   _typeL.indexOf('shirt') !== -1 || _typeL.indexOf('tee') !== -1;
    /* The bare weight tags (5/6.5/8.5/9) only PICK which orange oz badge to show —
       they are never rendered on their own. */
    var _weightTags = ['5', '6.5', '8.5', '9'];
    var _ozTag = null;
    if (_isTshirt) {
      (pd.tags || []).forEach(function (t) {
        if (_weightTags.indexOf(String(t).trim()) !== -1) _ozTag = String(t).trim();
      });
    }
    /* Silver: fineness (.999/.925/90%) shown like a size pill; weight shown orange (ozt = troy ounces or grams). */
    var _isSilver = _tagsLower.indexOf('silver') !== -1 || _typeL.indexOf('silver') !== -1;
    var _silverFineness = null, _silverWeight = null;
    if (_isSilver) {
      (pd.tags || []).forEach(function (t) {
        var _s = String(t).trim();
        if (/^(\.999|\.925|90%)\s*silver$/i.test(_s)) _silverFineness = _s;
        else if (/^[\d.]+\s*(ozt|oz|grams?|g)$/i.test(_s)) _silverWeight = _s;
      });
    }
    /* Blue "100% Cotton" first, then the orange "{N} oz T-Shirt" badge immediately
       to its right. */
    if (_isTshirt) {
      tagBubblesHtml += '<span class="fss-modal-tag fss-modal-tag-cotton">100% Cotton ' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:middle;margin-left:2px;" aria-hidden="true">' +
        '<circle cx="12" cy="9" r="3.5"/>' +
        '<ellipse cx="6.5" cy="13.5" rx="2.5" ry="3.2" transform="rotate(-20 6.5 13.5)"/>' +
        '<ellipse cx="17.5" cy="13.5" rx="2.5" ry="3.2" transform="rotate(20 17.5 13.5)"/>' +
        '<ellipse cx="12" cy="16" rx="2.5" ry="3.2"/>' +
        '<line x1="12" y1="19.5" x2="12" y2="23" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg></span>';
      if (_ozTag) {
        tagBubblesHtml += '<span class="fss-modal-tag fss-modal-tag-oz">' + _ozTag + ' oz T-Shirt</span>';
      }
    }
    /* Silver: fineness pill + orange weight badge */
    if (_isSilver) {
      if (_silverFineness) tagBubblesHtml += '<span class="fss-modal-tag fss-modal-tag-size">' + _silverFineness + '</span>';
      if (_silverWeight) tagBubblesHtml += '<span class="fss-modal-tag fss-modal-tag-oz">' + _silverWeight + '</span>';
    }
    /* Remaining tags — never show a bare weight number or a literal "oz t-shirt" tag
       (the orange badge above already represents it). Silver fineness/weight are shown above. */
    dedupeAndNormalizeTags(pd.tags).forEach(function (t) {
      var _t = String(t).trim();
      if (_weightTags.indexOf(_t) !== -1) return;
      if (/\boz\b[\s-]*t-?shirt|\boz\b[\s-]*tee/i.test(_t)) return;
      if (_isSilver && (/^(\.999|\.925|90%)\s*silver$/i.test(_t) || /^[\d.]+\s*(ozt|oz|grams?|g)$/i.test(_t))) return;
      tagBubblesHtml += '<span class="fss-modal-tag">' + t + '</span>';
    });
    var tagsHtml = tagBubblesHtml ? '<div class="fss-modal-tags">' + tagBubblesHtml + '</div>' : '';

    /* Description with optional show-more clamp. Long descriptions get clamped
       to ~4 lines so the modal fits without scrolling; user clicks "Show more"
       to expand. The threshold is rough — works for most product descriptions. */
    var descRaw = pd.description || '';
    var descHasMore = descRaw.length > 200;
    var descHtml = '';
    if (descRaw) {
      descHtml = '<div class="fss-modal-desc' + (descHasMore ? ' clamped' : '') +
        '" id="modal-desc" data-edit="description" data-pid="' + pd.id + '">' + descRaw + '</div>';
      if (descHasMore) {
        descHtml += '<button type="button" class="fss-modal-desc-toggle" id="modal-desc-toggle">Show more</button>';
      }
    }

    /* Variant selector — only shown when product has multiple variants */
    var variants = pd.variants || [];
    var hasVariants = variants.length > 1 &&
      !(variants.length === 1 && variants[0].title === 'Default Title');
    /* Pick the first available variant as the default */
    var selectedVariant = variants.find(function (v) { return v.available; }) || variants[0] || null;
    var selectedVid = selectedVariant ? selectedVariant.id : pd.variant_id;
    var selectedPrice = selectedVariant ? selectedVariant.price : pd.price;
    var selectedAvailable = selectedVariant ? selectedVariant.available : pd.available;
    var selectedStock = selectedVariant ? selectedVariant.inventory_quantity : pd.inventory_quantity;

    var variantHtml = '';
    if (hasVariants) {
      variantHtml = '<div class="fss-modal-variants" id="modal-variants">' +
        variants.map(function (v) {
          var isSelected = v.id === selectedVid;
          var cls = 'fss-variant-btn' + (isSelected ? ' selected' : '') + (!v.available ? ' unavailable' : '');
          return '<button class="' + cls + '" data-variant-id="' + v.id + '"' +
            ' data-price="' + v.price + '"' +
            ' data-available="' + v.available + '"' +
            ' data-stock="' + (v.inventory_quantity || 0) + '">' +
            v.title + '</button>';
        }).join('') +
        '</div>';
    }

    var inCart = cartState.items.find(function (i) { return String(i.product_id) === String(pd.id); });
    var cartQty = inCart ? inCart.quantity : 0;
    var btnDisabled = !selectedAvailable ? ' disabled' : '';
    var btnClass = inCart ? 'fss-add-to-cart-btn in-cart' : 'fss-add-to-cart-btn';
    var xBtn = '<span class="fss-atc-x-btn" aria-label="Remove from cart">&#x2715;</span>';
    var isMob = window.innerWidth < 768;
    var addBtnInner = !selectedAvailable
      ? '<span class="fss-atc-label">Sold</span>'
      : (inCart
        ? '<span class="fss-atc-label">View Cart</span>'
        : '<span class="fss-atc-label">Add to Cart</span>');
    var trashSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
    var minusSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    var plusSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

    var noImages = !pd.images || pd.images.length === 0;
    modalBody.innerHTML =
      imagesHtml +
      '<div class="fss-modal-info' + (noImages ? ' no-images' : '') + '">' +
      '<div class="fss-modal-info-top">' +
      '<div class="fss-modal-title-row">' +
      '<h2 class="fss-modal-title" data-edit="title" data-pid="' + pd.id + '">' + pd.title + '</h2>' +
      '<div class="fss-modal-price-inline" id="modal-price" data-edit="price" data-pid="' + pd.id + '">' + formatMoney(selectedPrice) + '</div>' +
      '</div>' +
      tagsHtml +
      variantHtml +
      descHtml +
      '</div>' +
      '<div class="fss-modal-bottom">' +
      '<div class="fss-modal-action-btns">' +
      (isMob ? '<span class="fss-mob-price-btn" id="mob-price-btn">' + formatMoney(selectedPrice) + '</span>' : '') +
      '<button class="' + btnClass + '" id="modal-add-btn" data-variant-id="' + selectedVid + '"' + btnDisabled + '>' + addBtnInner + '</button>' +
      '</div>' +
      '<div class="fss-modal-qty-col" id="modal-qty-col"' + (inCart ? '' : ' style="display:none;"') + '>' +
      '<div class="fss-modal-qty-row">' +
      '<button class="fss-modal-trash-btn" id="modal-trash">' + trashSvg + '</button>' +
      '<button class="fss-modal-qty-ctrl minus-btn" id="modal-qty-minus"' + (cartQty <= 1 ? ' disabled' : '') + '>' + minusSvg + '</button>' +
      '<input type="number" class="fss-modal-qty-val" id="modal-qty" value="' + (inCart ? cartQty : 1) + '" min="1">' +
      '<button class="fss-modal-qty-ctrl plus-btn" id="modal-qty-plus">' + plusSvg + '</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';

    /* Cancel any in-flight close animation so re-opening doesn't get hidden by it. */
    if (window._fssModalCloseTimer) {
      clearTimeout(window._fssModalCloseTimer);
      window._fssModalCloseTimer = null;
    }
    /* Move the modal to <body> so a transformed/filtered ancestor (e.g. the sticky
       search bar area) can't trap its position:fixed and make it drift with scroll. */
    if (modalOverlay.parentNode !== document.body) document.body.appendChild(modalOverlay);
    modalOverlay.style.display = '';
    modalOverlay.classList.remove('closing');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    /* Wire up image load events: reveal each image and hide its glass
       placeholder once the browser has decoded it. */
    if (imgs.length > 0) {
      {
        imgs.forEach(function (src, idx) {
          var imgEl = modalBody.querySelector('.fss-modal-img[data-slide="' + idx + '"]');
          var glassEl = document.getElementById('modal-glass-' + idx);
          if (!imgEl) return;
          function revealImg() {
            imgEl.classList.add('loaded');
            if (glassEl) glassEl.classList.add('hidden');
          }
          if (imgEl.complete && imgEl.naturalWidth > 0) {
            revealImg();
          } else {
            imgEl.addEventListener('load', revealImg);
            imgEl.addEventListener('error', revealImg);
          }
        });
      }
    }

    // Wire up modal controls
    var qtyInput = $('#modal-qty');
    var qtyMinus = $('#modal-qty-minus');
    var qtyPlus = $('#modal-qty-plus');
    var addBtn = $('#modal-add-btn');
    var trashBtn = $('#modal-trash');
    var qtyCol = $('#modal-qty-col');

    var descToggle = $('#modal-desc-toggle');
    var descEl = $('#modal-desc');

    /* Variant selector */
    var variantContainer = $('#modal-variants');
    if (variantContainer) {
      $$('.fss-variant-btn', variantContainer).forEach(function (vBtn) {
        vBtn.addEventListener('click', function () {
          if (this.classList.contains('unavailable')) return;
          $$('.fss-variant-btn', variantContainer).forEach(function (b) { b.classList.remove('selected'); });
          this.classList.add('selected');
          var newVid = parseInt(this.dataset.variantId);
          var newPrice = parseInt(this.dataset.price);
          var newAvail = this.dataset.available === 'true';
          var newStock = parseInt(this.dataset.stock) || 0;
          /* Update add button */
          if (addBtn) {
            addBtn.dataset.variantId = newVid;
            addBtn.disabled = !newAvail;
            if (!newAvail) {
              addBtn.innerHTML = '<span class="fss-atc-label">Sold</span>';
              addBtn.classList.remove('in-cart');
            } else {
              var cartItemForVariant = cartState.items.find(function (i) { return String(i.variant_id) === String(newVid); });
              if (cartItemForVariant) {
                addBtn.innerHTML = '<span class="fss-atc-label">View Cart</span>';
                addBtn.classList.add('in-cart');
              } else {
                addBtn.innerHTML = '<span class="fss-atc-label">Add to Cart</span>';
                addBtn.classList.remove('in-cart');
              }
            }
          }
          /* Update price */
          var priceEl = $('#modal-price');
          if (priceEl) priceEl.textContent = formatMoney(newPrice);
          /* Update max stock for + button */
          if (qtyPlus) {
            var cartItemQ = cartState.items.find(function (i) { return String(i.variant_id) === String(newVid); });
            var cartQ = cartItemQ ? cartItemQ.quantity : 0;
            qtyPlus.disabled = cartQ >= newStock;
          }
        });
      });
    }

    /* === ZOOM-ON-HOVER for the product images (desktop only) ===
       Lens follows cursor over the image (position: fixed on body so it stays
       aligned regardless of any scroll inside .fss-modal-images). The zoom
       pane covers .fss-modal-info, showing a high-res crop of the area under
       the lens. Mobile (< 768px) is skipped — touch has no hover concept. */
    if (window.matchMedia('(min-width: 768px)').matches) {
      var imageWrapEl = modalBody.querySelector('.fss-modal-images');
      var infoEl = modalBody.querySelector('.fss-modal-info');
      var modalImgs = modalBody.querySelectorAll('.fss-modal-img');
      if (imageWrapEl && infoEl && modalImgs.length > 0) {
        /* Both lens and pane are body-level singletons. The pane needs to
           position relative to the viewport (not the modal — which has a
           `transform` that would otherwise become its containing block and
           constrain fixed positioning to the modal's bounds). */
        var lens = document.getElementById('fss-zoom-lens');
        if (!lens) {
          lens = document.createElement('div');
          lens.className = 'fss-modal-zoom-lens';
          lens.id = 'fss-zoom-lens';
          document.body.appendChild(lens);
        }
        var pane = document.getElementById('fss-zoom-pane');
        if (!pane) {
          pane = document.createElement('div');
          pane.className = 'fss-modal-zoom-pane';
          pane.id = 'fss-zoom-pane';
          document.body.appendChild(pane);
        }
        /* Floating magnifier + "shake to zoom" hint, shown next to the cursor
           BEFORE the user has unlocked zoom. No loading ring, no auto-zoom —
           the user must shake or click to turn zoom on. Once unlocked (session
           flag), this never shows again and zoom is automatic on hover. */
        var ring = document.getElementById('fss-zoom-ring');
        if (!ring) {
          ring = document.createElement('div');
          ring.className = 'fss-zoom-ring fss-zoom-cue';
          ring.id = 'fss-zoom-ring';
          /* Just the text — the native `cursor: zoom-in` magnifying glass is
             the icon. The hint sits directly under the cursor point. */
          ring.innerHTML = '';
          document.body.appendChild(ring);
        }

        function highResUrl(url) {
          if (!url) return url;
          if (/width=\d+/.test(url)) return url.replace(/width=\d+/, 'width=1600');
          if (/[?&]width=\d+/.test(url)) return url.replace(/width=\d+/, 'width=1600');
          return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
        }

        var ZOOM_LENS_RATIO = 0.38;

        /* ---- state ---- */
        var zoomActive = false;
        var currentImg = null;
        /* Shake detection — reverse horizontal direction 2+ times within 500ms
           and 80px total travel → enable zoom. */
        var moveTimeline = [];
        function trackForShake(x, t) {
          moveTimeline.push({ x: x, t: t });
          while (moveTimeline.length > 0 && t - moveTimeline[0].t > 500) {
            moveTimeline.shift();
          }
          if (moveTimeline.length < 4) return false;
          var lastDir = 0, reversals = 0, totalDist = 0;
          for (var i = 1; i < moveTimeline.length; i++) {
            var dx = moveTimeline[i].x - moveTimeline[i - 1].x;
            if (Math.abs(dx) < 4) continue;
            totalDist += Math.abs(dx);
            var dir = dx > 0 ? 1 : -1;
            if (lastDir !== 0 && dir !== lastDir) reversals++;
            lastDir = dir;
          }
          return reversals >= 2 && totalDist >= 80;
        }
        function resetShakeTracking() { moveTimeline = []; }

        function showCue(e) {
          // cursor: zoom-in is sufficient; no floating hint shown
        }
        function hideCue() {
          ring.classList.remove('visible', 'show-hint');
        }

        function activateZoom() {
          if (zoomActive || !currentImg) return;
          zoomActive = true;
          zoomUnlocked = true; /* session: auto-zoom every image from now on */
          hideCue();
          var hi = highResUrl(currentImg.getAttribute('src'));
          pane.style.backgroundImage = 'url("' + hi + '")';
          pane.classList.add('visible');
          lens.classList.add('visible');
        }

        function resetAll() {
          zoomActive = false;
          hideCue();
          lens.classList.remove('visible');
          pane.classList.remove('visible');
          resetShakeTracking();
          currentImg = null;
        }

        function moveZoom(e, img) {
          var imgRect = img.getBoundingClientRect();
          var cx = e.clientX - imgRect.left;
          var cy = e.clientY - imgRect.top;
          if (cx < 0 || cy < 0 || cx > imgRect.width || cy > imgRect.height) {
            resetAll();
            return;
          }
          if (!zoomActive) return;
          /* Active zoom: position lens + pane crop. */
          var paneRect = pane.getBoundingClientRect();
          var lensSize = Math.min(imgRect.width, imgRect.height) * ZOOM_LENS_RATIO;
          var lensX = Math.max(0, Math.min(imgRect.width - lensSize, cx - lensSize / 2));
          var lensY = Math.max(0, Math.min(imgRect.height - lensSize, cy - lensSize / 2));
          lens.style.width = lensSize + 'px';
          lens.style.height = lensSize + 'px';
          lens.style.left = (imgRect.left + lensX) + 'px';
          lens.style.top = (imgRect.top + lensY) + 'px';
          var zoomFactor = Math.min(
            paneRect.width / lensSize,
            paneRect.height / lensSize
          );
          var bgW = imgRect.width * zoomFactor;
          var bgH = imgRect.height * zoomFactor;
          var lensCx = lensX + lensSize / 2;
          var lensCy = lensY + lensSize / 2;
          var bgX = paneRect.width / 2 - (lensCx / imgRect.width) * bgW;
          var bgY = paneRect.height / 2 - (lensCy / imgRect.height) * bgH;
          pane.style.backgroundSize = bgW + 'px ' + bgH + 'px';
          pane.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
        }

        modalImgs.forEach(function (img) {
          img.addEventListener('mouseenter', function (e) {
            currentImg = img;
            resetShakeTracking();
            if (zoomUnlocked) {
              /* Already unlocked this session → zoom immediately on hover. */
              activateZoom();
            } else {
              showCue(e);
            }
          });
          img.addEventListener('mouseleave', resetAll);
          img.addEventListener('mousemove', function (e) { moveZoom(e, img); });
          /* Click → enable zoom right away (alternative to shaking). */
          img.addEventListener('click', function (e) {
            if (zoomActive) return;
            e.preventDefault();
            currentImg = img;
            activateZoom();
          });
        });
      }
    }
    /* Make sure any orphan lens from a previous open is hidden when this one closes. */

    if (descToggle && descEl) {
      /* Verify the description actually overflows before showing the toggle.
         Char-count > 200 is a rough trigger; if the rendered text happens to
         fit within the 4-line clamp anyway, hide the toggle. */
      requestAnimationFrame(function () {
        if (descEl.scrollHeight <= descEl.clientHeight + 2) {
          descToggle.style.display = 'none';
          descEl.classList.remove('clamped');
        }
      });
      descToggle.addEventListener('click', function () {
        var expanded = descEl.classList.toggle('expanded');
        descEl.classList.toggle('clamped', !expanded);
        descToggle.textContent = expanded ? 'Show less' : 'Show more';
      });
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) {
        v--;
        qtyInput.value = v;
        qtyMinus.disabled = (v <= 1);
        if (qtyPlus) qtyPlus.disabled = false;
        var vid = parseInt(addBtn.dataset.variantId);
        var item = cartState.items.find(function (i) { return String(i.variant_id) === String(vid); });
        if (item) changeCartItem(cartState.items.indexOf(item) + 1, v);
      }
    });
    var maxStock = pd.inventory_quantity || 999;
    if (qtyPlus) qtyPlus.addEventListener('click', function (e) {
      var v = parseInt(qtyInput.value) || 1;
      if (v >= maxStock) return;
      v++;
      qtyInput.value = v;
      qtyMinus.disabled = false;
      if (v >= maxStock) qtyPlus.disabled = true;
      triggerStarExplosion(e.clientX, e.clientY, 1, 28);
      var vid = parseInt(addBtn.dataset.variantId);
      var item = cartState.items.find(function (i) { return String(i.variant_id) === String(vid); });
      if (item) changeCartItem(cartState.items.indexOf(item) + 1, v);
    });
    if (qtyInput) qtyInput.addEventListener('blur', function () {
      var v = parseInt(qtyInput.value) || 1;
      if (v < 1) v = 1;
      if (v > maxStock) v = maxStock;
      qtyInput.value = v;
      qtyMinus.disabled = (v <= 1);
      if (qtyPlus) qtyPlus.disabled = (v >= maxStock);
      var vid = parseInt(addBtn.dataset.variantId);
      var item = cartState.items.find(function (i) { return String(i.variant_id) === String(vid); });
      if (item) changeCartItem(cartState.items.indexOf(item) + 1, v);
    });
    if (trashBtn) trashBtn.addEventListener('click', function () {
      addBtn.classList.remove('in-cart');
      addBtn.innerHTML = '<span class="fss-atc-label">Add to Cart</span>';
      if (qtyCol) qtyCol.style.display = 'none';
      qtyInput.value = 1;
      if (qtyMinus) qtyMinus.disabled = true;
      var vid = parseInt(addBtn.dataset.variantId);
      var item = cartState.items.find(function (i) { return String(i.variant_id) === String(vid); });
      if (item) changeCartItem(cartState.items.indexOf(item) + 1, 0);
    });
    if (addBtn) addBtn.addEventListener('click', function (e) {
      if (this.disabled) return;
      var vid = parseInt(this.dataset.variantId);
      var btnEl = this;
      var mob = window.innerWidth < 768;
      if (btnEl.classList.contains('in-cart')) {
        // "View Cart" — always open cart
        closeProductModal();
        setTimeout(openCartDrawer, 120);
        return;
      } else {
        triggerStarExplosion(e.clientX, e.clientY, 1, 30);
        var qty = parseInt(qtyInput.value) || 1;
        btnEl.classList.add('in-cart');
        btnEl.innerHTML = '<span class="fss-atc-label">View Cart</span>';
        if (qtyCol) qtyCol.style.display = '';
        qtyInput.value = qty;
        if (qtyMinus) qtyMinus.disabled = (qty <= 1);
        addToCart(vid, qty);
      }
    });

    // Mobile carousel swipe  (uses `imgs` — includes the duplicated single image)
    var slidesEl = $('#modal-slides');
    if (slidesEl && imgs && imgs.length > 1 && window.innerWidth < 768) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchCurrentX = 0;
      var currentSlide = 0;
      var totalSlides = imgs.length;
      var decided = false;
      var swipeDir = null;

      slidesEl.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchCurrentX = touchStartX;
        decided = false;
        swipeDir = null;
        slidesEl.style.transition = 'none';
      });
      slidesEl.addEventListener('touchmove', function (e) {
        touchCurrentX = e.touches[0].clientX;
        var dx = touchCurrentX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        if (!decided) {
          if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
            decided = true;
            swipeDir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
          }
        }
        if (swipeDir === 'h') {
          e.preventDefault();
          var offset = -currentSlide * 100 + (dx / slidesEl.parentElement.offsetWidth) * 100;
          slidesEl.style.transform = 'translateX(' + offset + '%)';
        }
      }, { passive: false });
      slidesEl.addEventListener('touchend', function () {
        if (swipeDir === 'h') {
          slidesEl.style.transition = 'transform 0.3s ease';
          var diff = touchCurrentX - touchStartX;
          var threshold = slidesEl.parentElement.offsetWidth * 0.2;
          if (diff < -threshold && currentSlide < totalSlides - 1) currentSlide++;
          else if (diff > threshold && currentSlide > 0) currentSlide--;
          slidesEl.style.transform = 'translateX(' + (-currentSlide * 100) + '%)';
          var allDots = $$('.fss-modal-dot');
          allDots.forEach(function (d, i) { d.classList.toggle('active', i === currentSlide); });
        }
        decided = false;
        swipeDir = null;
      });
    }
    // Dot click navigation
    $$('.fss-modal-dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(this.dataset.dot);
        var slides = $('#modal-slides');
        if (!slides) return;
        if (window.innerWidth < 768) {
          slides.style.transition = 'transform 0.3s ease';
          slides.style.transform = 'translateX(' + (-idx * 100) + '%)';
        } else {
          var imgs = $$('.fss-modal-img');
          if (imgs[idx]) imgs[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        $$('.fss-modal-dot').forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      });
    });
  }

  function closeProductModal() {
    if (!modalOverlay) return;
    if (modalOverlay.style.display === 'none') return;
    if (modalOverlay.classList.contains('closing')) return;
    /* Hide the zoom lens and pane (body children, not inside the overlay)
       so they don't hang around after the modal closes. */
    var zoomLens = document.getElementById('fss-zoom-lens');
    if (zoomLens) zoomLens.classList.remove('visible');
    var zoomPane = document.getElementById('fss-zoom-pane');
    if (zoomPane) zoomPane.classList.remove('visible');
    var zoomRing = document.getElementById('fss-zoom-ring');
    if (zoomRing) zoomRing.classList.remove('visible', 'show-hint');
    modalOverlay.classList.add('closing');
    /* Wait for the reverse fadeSlideDown animation to finish, then hide. */
    window._fssModalCloseTimer = setTimeout(function () {
      modalOverlay.style.display = 'none';
      modalOverlay.classList.remove('closing');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      window._fssModalCloseTimer = null;
    }, 220);
  }
  if (modalOverlay) modalOverlay.addEventListener('click', function (e) {
    if (e.target === modalOverlay) closeProductModal();
  });
  if (modalClose) modalClose.addEventListener('click', closeProductModal);

  /* ---- PRODUCT DETAIL PAGE ---- */
  var pdpAddBtn = $('#pdp-add-to-cart');
  var pdpQtyInput = $('#pdp-qty');
  var pdpQtyMinus = $('#pdp-qty-minus');
  var pdpQtyPlus = $('#pdp-qty-plus');

  if (pdpQtyMinus && pdpQtyInput) {
    pdpQtyMinus.addEventListener('click', function () {
      var v = parseInt(pdpQtyInput.value) || 1;
      if (v > 1) pdpQtyInput.value = v - 1;
    });
  }
  if (pdpQtyPlus && pdpQtyInput) {
    pdpQtyPlus.addEventListener('click', function () {
      pdpQtyInput.value = (parseInt(pdpQtyInput.value) || 1) + 1;
    });
  }
  if (pdpAddBtn) {
    pdpAddBtn.addEventListener('click', function (e) {
      triggerStarExplosion(e.clientX, e.clientY, 1, 30);
      var vid = parseInt(this.dataset.variantId);
      var qty = parseInt(pdpQtyInput.value) || 1;
      this.textContent = 'Adding...';
      this.disabled = true;
      addToCart(vid, qty, function () {
        pdpAddBtn.textContent = 'Added!';
        setTimeout(function () {
          pdpAddBtn.textContent = 'Add to Cart';
          pdpAddBtn.disabled = false;
        }, 1500);
        openCartDrawer();
      });
    });
  }

  // Product detail image gallery
  var thumbs = $$('.fss-product-thumb');
  var imageWraps = $$('.fss-product-image-wrap');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = this.dataset.imageIndex;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      imageWraps.forEach(function (w) { w.classList.remove('active'); });
      this.classList.add('active');
      var target = imageWraps.find(function (w) { return w.dataset.imageIndex === idx; });
      if (target) target.classList.add('active');
    });
  });


  /* ---- MOBILE GRID SPLIT: 3-col (first 9 visible) + 2-col (remaining) ---- */
  var grid2col = $('#product-grid-2col');
  function splitMobileGrid() {
    if (!productGrid) return;
    var mobile = window.innerWidth < 1024;

    /* Consolidate any previously-split overflow back into the main grid first. */
    if (grid2col) Array.from(grid2col.children).forEach(function (c) { productGrid.appendChild(c); });

    /* Left-margin products: inline them at the FRONT of the grid on mobile so they
       display like any other tile; return them to the hidden mobile-margin-row on desktop
       (where the left sidebar shows them instead). */
    if (mobileMarginRow) {
      if (mobile) {
        var tiles = Array.from(mobileMarginRow.children);
        for (var i = tiles.length - 1; i >= 0; i--) productGrid.insertBefore(tiles[i], productGrid.firstChild);
      } else {
        Array.prototype.slice.call(productGrid.querySelectorAll('.fss-mobile-margin-tile'))
          .forEach(function (c) { mobileMarginRow.appendChild(c); });
      }
    }

    /* Two-grid overflow split (both grids are 2-wide on mobile, so this is seamless). */
    if (mobile && grid2col) {
      var visibleCount = 0;
      var cards = Array.from(productGrid.children);
      for (var si = 0; si < cards.length; si++) {
        if (cards[si].style.display !== 'none') visibleCount++;
        if (visibleCount > 9) grid2col.appendChild(cards[si]);
      }
    }
  }
  splitMobileGrid();
  window.addEventListener('resize', (function () {
    var timer;
    return function () { clearTimeout(timer); timer = setTimeout(splitMobileGrid, 150); };
  })());

  /* Shared reference so the rectangle's 4.2s hover can trigger the star
     explosion that lives in the green-circle block below (set there). */
  var fssExplodeBox = null;

  /* ---- HOVER SQUARE: 4.2s hover → EXPLODE all stars out of the box ----
     Hovering (or press-hold) the rectangle for 4.2s frees every star in the
     box; they burst out and fall off the bottom of the screen. The glow ramps
     via CSS during the hold as a wind-up. */
  var hoverSquare = $('#hover-square');
  if (hoverSquare) {
    var HOVER_HOLD_MS = 5000;
    var hoverTimer = null;
    var burstResetTimer = null;
    var cooldownUntil = 0;
    /* Track the most recent cursor / touch position over the square so the
       star burst fires from exactly where the user is hovering, not from the
       square's static center. Null means "haven't seen a position yet" — in
       that case (e.g. keyboard focus) we fall back to the center. */
    var lastX = null;
    var lastY = null;

    function squareCenter() {
      var r = hoverSquare.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    function updatePos(x, y) { lastX = x; lastY = y; }
    function burstOrigin() {
      if (lastX !== null && lastY !== null) return { x: lastX, y: lastY };
      return squareCenter();
    }

    /* Auto-looping while hovered: glow-ramp (4.2s) → explode → 800ms burst/
       recharge → restart, continuously, until the cursor leaves. No need to
       exit and re-enter the square to re-arm. */
    var squareHovering = false;
    var rechargeTimer = null;
    var greenDelayTimer = null;
    function runSquareCycle() {
      if (!squareHovering) return;
      hoverSquare.classList.remove('burst', 'recharging');
      hoverSquare.classList.add('hovering');
      hoverTimer = setTimeout(function () {
        hoverTimer = null;
        /* Free every star in the box → they fall off-screen, toggling the
           green/blue circle for every 5 that exit. */
        if (fssExplodeBox) fssExplodeBox();
        hoverSquare.classList.remove('hovering');
        hoverSquare.classList.add('burst', 'recharging');
        if (burstResetTimer) clearTimeout(burstResetTimer);
        burstResetTimer = setTimeout(function () {
          hoverSquare.classList.remove('burst');
          if (rechargeTimer) clearTimeout(rechargeTimer);
          rechargeTimer = setTimeout(function () {
            hoverSquare.classList.remove('recharging');
            /* Restart the cycle if the cursor is still on the square. */
            if (squareHovering) runSquareCycle();
          }, 450);
        }, 350);
      }, HOVER_HOLD_MS);
    }

    function startHold() {
      if (squareHovering) return;
      squareHovering = true;
      /* Delay the green glow — a quick tap/click should NOT show green; only a
         click-AND-HOLD (past this delay) starts the green charge cycle. */
      if (greenDelayTimer) clearTimeout(greenDelayTimer);
      greenDelayTimer = setTimeout(function () {
        greenDelayTimer = null;
        if (squareHovering) runSquareCycle();
      }, 220);
    }

    function cancelHold() {
      squareHovering = false;
      if (greenDelayTimer) { clearTimeout(greenDelayTimer); greenDelayTimer = null; }
      if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      if (burstResetTimer) { clearTimeout(burstResetTimer); burstResetTimer = null; }
      if (rechargeTimer) { clearTimeout(rechargeTimer); rechargeTimer = null; }
      hoverSquare.classList.remove('hovering', 'burst', 'recharging');
      lastX = null;
      lastY = null;
    }

    /* Re-enabled: hovering (desktop) or press-holding (mobile) the square runs
       the charge → explode loop that frees every star in the box in a burst.
       touchHoldStart is read by the box's tap-to-spawn handler below (same IIFE
       scope) to tell a quick tap apart from a hold. */
    var touchHoldStart = 0;
    var touchStartXY = null;
    var touchMovedDist = 0;
    hoverSquare.addEventListener('mouseenter', startHold);
    hoverSquare.addEventListener('mouseleave', cancelHold);
    hoverSquare.addEventListener('mousemove', function (e) { updatePos(e.clientX, e.clientY); });
    /* Mobile: do NOT preventDefault — the page must still scroll if the user drags
       starting on the square. A quick tap spawns a star (touchend handler below);
       a HOLD still charges the green glow even while the page scrolls. */
    hoverSquare.addEventListener('touchstart', function (e) {
      touchHoldStart = Date.now();
      touchMovedDist = 0;
      if (e.touches[0]) {
        touchStartXY = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        updatePos(e.touches[0].clientX, e.touches[0].clientY);
      }
      startHold();
    }, { passive: true });
    hoverSquare.addEventListener('touchmove', function (e) {
      if (e.touches[0]) {
        updatePos(e.touches[0].clientX, e.touches[0].clientY);
        if (touchStartXY) {
          touchMovedDist = Math.max(touchMovedDist,
            Math.abs(e.touches[0].clientX - touchStartXY.x) + Math.abs(e.touches[0].clientY - touchStartXY.y));
        }
      }
    }, { passive: true });
    hoverSquare.addEventListener('touchend', cancelHold);
    hoverSquare.addEventListener('touchcancel', cancelHold);
    hoverSquare.addEventListener('focus', startHold);
    hoverSquare.addEventListener('blur', cancelHold);
  }

  /* ---- GREEN CIRCLE → BLUE: loading ring on hover, then drop physics stars ----
     Hovering the small green corner icon in the waitlist card fills a loading
     ring. When it completes, 5 real star-image particles fall from the circle
     into the rectangle box with full physics — gravity, wall bounces, and
     star-to-star collisions — settling in a pile at the bottom. Each hover
     adds 5 more. The circle turns blue once it fires. */
  var circleIcon = document.querySelector('.fss-waitlist-icon');
  var hoverCard = document.querySelector('.fss-waitlist-card');
  var hoverBox = document.getElementById('hover-square');
  if (circleIcon && hoverCard && hoverBox) {
    var CIRCLE_HOLD_MS = 2000;
    var STAR_COUNT = 5;

    var circleRing = document.createElement('div');
    circleRing.className = 'fss-circle-ring';
    circleRing.innerHTML =
      '<svg viewBox="0 0 40 40" width="56" height="56">' +
        '<circle class="fss-zoom-ring-track" cx="20" cy="20" r="17"/>' +
        '<circle class="fss-zoom-ring-bar"   cx="20" cy="20" r="17"/>' +
      '</svg>';
    circleIcon.appendChild(circleRing);

    /* Physics canvas overlaying the whole card (clipped by card overflow). */
    var pcv = document.createElement('canvas');
    pcv.className = 'fss-card-star-canvas';
    hoverCard.appendChild(pcv);
    var pctx = pcv.getContext('2d');

    var MAX_STARS = 90;       /* cap the pile so it can't overflow the box into a mess */
    var STAR_SIZE = 24;       /* drawn px */
    var STAR_RADIUS = 9.5;    /* collision circle (smaller than half so they nest) */
    var GRAVITY = 0.55;
    var WALL_BOUNCE = 0.42;   /* restitution off box walls/floor */
    var AIR_DRAG = 0.992;
    var FLOOR_FRICTION = 0.86;
    var PAIR_BOUNCE = 0.35;   /* restitution between stars */

    var cardStars = [];
    var pAnim = null;
    var settleFrames = 0;
    /* Box bounds, card-relative — recomputed on each drop + on resize. */
    var bx = { left: 0, right: 0, top: 0, bottom: 0 };

    function sizeCanvas() {
      var r = hoverCard.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      pcv.style.width = r.width + 'px';
      pcv.style.height = r.height + 'px';
      pcv.width = Math.round(r.width * dpr);
      pcv.height = Math.round(r.height * dpr);
      pctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function computeBounds() {
      var cardRect = hoverCard.getBoundingClientRect();
      var boxRect = hoverBox.getBoundingClientRect();
      bx.left = boxRect.left - cardRect.left;
      bx.right = boxRect.right - cardRect.left;
      bx.top = boxRect.top - cardRect.top;
      bx.bottom = boxRect.bottom - cardRect.top;
    }

    /* Add a single physics star at a card-relative point (used by box clicks).
       Clamped into the box span so it always lands inside the rectangle. */
    function addStar(cx, cy) {
      sizeCanvas();
      computeBounds();
      cx = Math.max(bx.left + STAR_RADIUS, Math.min(bx.right - STAR_RADIUS, cx));
      cy = Math.max(bx.top - STAR_SIZE, Math.min(bx.bottom - STAR_RADIUS, cy));
      cardStars.push({
        x: cx,
        y: cy,
        vx: (Math.random() - 0.5) * 2,
        vy: 0,
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.2
      });
      if (cardStars.length > MAX_STARS) cardStars.splice(0, cardStars.length - MAX_STARS);
      settleFrames = 0;
      ensureLoop();
    }

    function stepPhysics() {
      var i, j, s;
      /* Integrate + wall constraints */
      for (i = 0; i < cardStars.length; i++) {
        s = cardStars[i];
        s.vy += GRAVITY;
        s.vx *= AIR_DRAG;
        s.x += s.vx;
        s.y += s.vy;
        s.rot += s.vr;
        s.vr *= 0.97;

        /* Left/right walls of the box */
        if (s.x - STAR_RADIUS < bx.left) {
          s.x = bx.left + STAR_RADIUS;
          s.vx = Math.abs(s.vx) * WALL_BOUNCE;
          s.vr += s.vy * 0.01;
        } else if (s.x + STAR_RADIUS > bx.right) {
          s.x = bx.right - STAR_RADIUS;
          s.vx = -Math.abs(s.vx) * WALL_BOUNCE;
          s.vr -= s.vy * 0.01;
        }
        /* Floor (bottom of box) */
        if (s.y + STAR_RADIUS > bx.bottom) {
          s.y = bx.bottom - STAR_RADIUS;
          if (s.vy > 0) s.vy = -s.vy * WALL_BOUNCE;
          s.vx *= FLOOR_FRICTION;
          s.vr *= FLOOR_FRICTION;
          if (Math.abs(s.vy) < 0.6) s.vy = 0;
        }
        /* Soft ceiling so a fresh drop on top of a tall pile can't escape upward */
        if (s.y - STAR_RADIUS < bx.top - STAR_SIZE) {
          s.y = bx.top - STAR_SIZE + STAR_RADIUS;
          if (s.vy < 0) s.vy = 0;
        }
      }

      /* Star-to-star collisions (O(n²) — fine for a handful of stars) */
      for (i = 0; i < cardStars.length; i++) {
        for (j = i + 1; j < cardStars.length; j++) {
          var a = cardStars[i], b = cardStars[j];
          var dx = b.x - a.x, dy = b.y - a.y;
          var dist = Math.sqrt(dx * dx + dy * dy) || 0.0001;
          var minDist = STAR_RADIUS * 2;
          if (dist < minDist) {
            var nx = dx / dist, ny = dy / dist;
            var overlap = (minDist - dist) / 2;
            /* Separate the pair */
            a.x -= nx * overlap; a.y -= ny * overlap;
            b.x += nx * overlap; b.y += ny * overlap;
            /* Exchange velocity along the collision normal */
            var rvx = b.vx - a.vx, rvy = b.vy - a.vy;
            var velAlong = rvx * nx + rvy * ny;
            if (velAlong < 0) {
              var imp = -(1 + PAIR_BOUNCE) * velAlong / 2;
              a.vx -= imp * nx; a.vy -= imp * ny;
              b.vx += imp * nx; b.vy += imp * ny;
            }
          }
        }
      }
    }

    function drawStars() {
      pctx.clearRect(0, 0, pcv.width, pcv.height);
      var canDraw = !!(starImage && starLoaded);
      var isDarkMode = document.documentElement.classList.contains('dark');
      for (var i = 0; i < cardStars.length; i++) {
        var s = cardStars[i];
        pctx.save();
        pctx.translate(s.x, s.y);
        pctx.rotate(s.rot);
        if (canDraw) {
          /* star_icon.png is black; invert in dark mode so stars are white */
          pctx.filter = isDarkMode ? 'invert(1)' : 'none';
          pctx.drawImage(starImage, -STAR_SIZE / 2, -STAR_SIZE / 2, STAR_SIZE, STAR_SIZE);
        } else {
          /* Fallback dot until the star image finishes loading */
          pctx.fillStyle = '#22c55e';
          pctx.beginPath();
          pctx.arc(0, 0, STAR_RADIUS, 0, Math.PI * 2);
          pctx.fill();
        }
        pctx.restore();
      }
    }

    function physicsLoop() {
      stepPhysics();
      drawStars();
      /* Stop the loop once everything has settled (saves CPU). Keeps the last
         frame painted. Restarts when a new drop happens. */
      var maxSpeed = 0;
      for (var i = 0; i < cardStars.length; i++) {
        var sp = Math.abs(cardStars[i].vx) + Math.abs(cardStars[i].vy);
        if (sp > maxSpeed) maxSpeed = sp;
      }
      if (maxSpeed < 0.25) settleFrames++; else settleFrames = 0;
      if (settleFrames > 40 || cardStars.length === 0) {
        pAnim = null; /* idle */
      } else {
        pAnim = requestAnimationFrame(physicsLoop);
      }
    }
    function ensureLoop() {
      if (!pAnim) { settleFrames = 0; pAnim = requestAnimationFrame(physicsLoop); }
    }

    /* Per-5-stars color toggle: the circle starts green and flips green↔blue
       (.fired) for every 5 stars that fall off the bottom of the screen. */
    var totalExited = 0;
    function countStarExit() {
      totalExited++;
      if (totalExited % 5 === 0) circleIcon.classList.toggle('fired');
    }

    /* EXPLOSION: free every star in the box and launch them onto the global
       full-screen star canvas so they burst upward/outward and then fall off
       the bottom of the screen (the card's overflow:hidden would otherwise
       clip them). Each one carries an onExit callback to drive the color toggle. */
    function explode() {
      if (cardStars.length === 0) return;
      var cardRect = hoverCard.getBoundingClientRect();
      if (starCanvas && (starCanvas.width !== window.innerWidth || starCanvas.height !== window.innerHeight)) {
        starCanvas.width = window.innerWidth;
        starCanvas.height = window.innerHeight;
      }
      cardStars.forEach(function (s) {
        starParticles.push({
          x: cardRect.left + s.x - STAR_SIZE / 2,
          y: cardRect.top + s.y - STAR_SIZE / 2,
          width: STAR_SIZE,
          height: STAR_SIZE,
          velocityX: (Math.random() - 0.5) * 20,
          velocityY: Math.random() * -18 - 6,
          gravity: 0.8,
          drag: 0.99,
          rotation: s.rot * 180 / Math.PI,
          rotationSpeed: (Math.random() - 0.5) * 14,
          onExit: countStarExit
        });
      });
      cardStars.length = 0;
      pctx.clearRect(0, 0, pcv.width, pcv.height);
      if (!starAnimFrame) animateStars();
    }

    /* Expose the explosion so the rectangle's 4.2s hover can trigger it. */
    fssExplodeBox = explode;

    /* Drop 5 stars from the green circle into the box (the circle's job). */
    function dropFiveStars() {
      sizeCanvas();
      computeBounds();
      var cardRect = hoverCard.getBoundingClientRect();
      var iconRect = circleIcon.getBoundingClientRect();
      var sx = iconRect.left + iconRect.width / 2 - cardRect.left;
      var sy = iconRect.top + iconRect.height / 2 - cardRect.top;
      sx = Math.max(bx.left + STAR_RADIUS, Math.min(bx.right - STAR_RADIUS, sx));
      for (var i = 0; i < STAR_COUNT; i++) {
        cardStars.push({
          x: sx + (Math.random() - 0.5) * 8,
          y: sy + (Math.random() - 0.5) * 8,
          vx: (Math.random() - 0.5) * 3.2,
          vy: Math.random() * 1.5,
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.25
        });
      }
      if (cardStars.length > MAX_STARS) cardStars.splice(0, cardStars.length - MAX_STARS);
      settleFrames = 0;
      ensureLoop();
    }

    /* "Impress" the square — a quick press-in + spring-back for tactile feedback
       on each tap / click. Re-triggerable: remove the class, force reflow, re-add. */
    function impressSquare() {
      hoverBox.classList.remove('fss-square-impress');
      /* eslint-disable-next-line no-unused-expressions */
      hoverBox.offsetWidth; /* reflow so the animation restarts */
      hoverBox.classList.add('fss-square-impress');
    }
    hoverBox.addEventListener('animationend', function (e) {
      if (e.animationName === 'fss-square-impress') hoverBox.classList.remove('fss-square-impress');
    });

    /* Click anywhere in the rectangle box → press-in + spawn one star. */
    hoverBox.addEventListener('click', function (e) {
      impressSquare();
      var cardRect = hoverCard.getBoundingClientRect();
      addStar(e.clientX - cardRect.left, e.clientY - cardRect.top);
    });
    /* Mobile: spawn on a quick TAP only — a drag (scroll) spawns nothing.
       preventDefault on the tap suppresses the synthesized click (no double spawn). */
    hoverBox.addEventListener('touchend', function (e) {
      /* touchHoldStart / touchMovedDist are declared in the hoverSquare block (same IIFE scope) */
      var isTap = typeof touchHoldStart !== 'undefined' && Date.now() - touchHoldStart < 300 &&
                  (typeof touchMovedDist === 'undefined' || touchMovedDist < 12);
      if (isTap && e.changedTouches[0]) {
        if (e.cancelable) e.preventDefault();
        impressSquare();
        var cardRect = hoverCard.getBoundingClientRect();
        var t = e.changedTouches[0];
        addStar(t.clientX - cardRect.left, t.clientY - cardRect.top);
      }
    }, { passive: false });

    /* Green-circle loading ring — auto-loops while hovered: fill ring (2s) →
       drop 5 stars → fill again → drop again, continuously, until mouseleave.
       The ring fill is driven by inline stroke-dashoffset so each cycle can
       restart cleanly without the class-toggle reverse-animating. */
    var circleBar = circleRing.querySelector('.fss-zoom-ring-bar');
    var circleTimer = null;
    var circleHovering = false;

    function fillRingOnce() {
      if (!circleBar) return;
      circleBar.style.transition = 'none';
      circleBar.style.strokeDashoffset = '107';
      /* force reflow so the reset takes effect before we animate */
      /* eslint-disable-next-line no-unused-expressions */
      circleBar.getBoundingClientRect();
      circleBar.style.transition = 'stroke-dashoffset ' + (CIRCLE_HOLD_MS / 1000) + 's linear';
      circleBar.style.strokeDashoffset = '0';
    }
    function runCircleCycle() {
      if (!circleHovering) return;
      circleRing.classList.add('visible');
      fillRingOnce();
      circleTimer = setTimeout(function () {
        circleTimer = null;
        dropFiveStars();
        if (circleHovering) runCircleCycle();
        else circleRing.classList.remove('visible');
      }, CIRCLE_HOLD_MS);
    }
    function startCircleLoad() {
      if (circleHovering) return;
      circleHovering = true;
      runCircleCycle();
    }
    function cancelCircleLoad() {
      circleHovering = false;
      if (circleTimer) { clearTimeout(circleTimer); circleTimer = null; }
      circleRing.classList.remove('visible');
    }

    circleIcon.addEventListener('mouseenter', startCircleLoad);
    circleIcon.addEventListener('mouseleave', cancelCircleLoad);
    circleIcon.addEventListener('touchstart', function (e) {
      e.preventDefault();
      startCircleLoad();
    }, { passive: false });
    circleIcon.addEventListener('touchend', cancelCircleLoad);
    circleIcon.addEventListener('touchcancel', cancelCircleLoad);

    /* Keep the canvas + bounds + pile in sync on resize. Re-settle the pile
       onto the (possibly moved) floor by nudging the loop awake. */
    window.addEventListener('resize', (function () {
      var rt;
      return function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          if (cardStars.length === 0) return;
          sizeCanvas();
          computeBounds();
          ensureLoop();
        }, 150);
      };
    })());
  }

  /* ---- MOBILE MARKETPLACE LINK: first tap highlights, second tap navigates ----
     On desktop the link works as a normal <a>. On touch/mobile we intercept
     the first tap: prevent navigation, apply a highlight class. A second tap
     within 1.5s navigates as usual. */
  var mobileMpLink = document.querySelector('[data-mobile-marketplace]');
  if (mobileMpLink) {
    var mpTapped = false;
    var mpResetTimer = null;
    mobileMpLink.addEventListener('click', function (e) {
      /* Only intervene on actual touch devices */
      if (!('ontouchstart' in window) && !window.matchMedia('(max-width: 1023px)').matches) return;
      if (!mpTapped) {
        e.preventDefault();
        mpTapped = true;
        mobileMpLink.classList.add('tapped');
        if (mpResetTimer) clearTimeout(mpResetTimer);
        mpResetTimer = setTimeout(function () {
          mpTapped = false;
          mobileMpLink.classList.remove('tapped');
        }, 1500);
      }
      /* second tap within 1.5s → let the click navigate naturally */
    });
  }

  /* Cancel bar removed — no longer shown on mobile */

  /* Visual viewport: update --fss-vvh so the cancel bar sits just above the
     keyboard (the keyboard shrinks the visual viewport height). */
  if (window.visualViewport) {
    function updateVvh() {
      document.documentElement.style.setProperty('--fss-vvh', window.visualViewport.height + 'px');
    }
    window.visualViewport.addEventListener('resize', updateVvh);
    updateVvh();
  }

  /* ---- MODAL: MOBILE PINCH-ZOOM + SWIPE-DOWN-TO-CLOSE ----
     Hooked on the modal body's container at the delegated level since the
     modal HTML is re-rendered on every open. */
  var modalOverlayEl = $('#product-modal-overlay');
  if (modalOverlayEl) {
    var pinchStartDist = 0;
    var pinchTargetImg = null;
    var swipeStartY = null;
    var swipeStartTime = 0;

    modalOverlayEl.addEventListener('touchstart', function (e) {
      /* Pinch-zoom: 2 fingers on a modal image */
      if (e.touches.length === 2) {
        var t = e.target.closest('.fss-modal-img');
        if (t) {
          pinchTargetImg = t;
          var dx = e.touches[0].clientX - e.touches[1].clientX;
          var dy = e.touches[0].clientY - e.touches[1].clientY;
          pinchStartDist = Math.sqrt(dx * dx + dy * dy);
          pinchTargetImg.classList.add('pinching');
          e.preventDefault();
        }
      } else if (e.touches.length === 1) {
        /* Track for potential swipe-down-to-close */
        swipeStartY = e.touches[0].clientY;
        swipeStartTime = Date.now();
      }
    }, { passive: false });

    modalOverlayEl.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchTargetImg && pinchStartDist > 0) {
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var scale = Math.max(1, Math.min(3, dist / pinchStartDist));
        pinchTargetImg.style.transform = 'scale(' + scale + ')';
        e.preventDefault();
      }
    }, { passive: false });

    modalOverlayEl.addEventListener('touchend', function (e) {
      if (pinchTargetImg && e.touches.length < 2) {
        /* Snap back to scale 1 when released */
        pinchTargetImg.classList.remove('pinching');
        pinchTargetImg.style.transform = 'scale(1)';
        pinchTargetImg = null;
        pinchStartDist = 0;
      }
      /* Swipe-down close: large vertical movement, brief duration, ending below */
      if (swipeStartY !== null && e.changedTouches.length > 0) {
        var dy2 = e.changedTouches[0].clientY - swipeStartY;
        var dt = Date.now() - swipeStartTime;
        if (dy2 > 120 && dt < 700) {
          if (typeof closeProductModal === 'function') closeProductModal();
        }
        swipeStartY = null;
      }
    });
  }


  /* ===== STAR UP ("/*" button) =====
     - Click → toggles the account dropdown (Account / Profile / Transactions / Settings).
     - 5 clicks in a row (each within 700ms) → downloads the elliptic-curve history
       .txt. Each click also logs one fresh random curve to the history.
     The button always shows "/*" (no canvas/toy), so a reload never shows a stray
     white circle. */
  var starUpBtn = $('#star-up-btn');
  var starUpMenu = $('#starup-menu');
  var starWrap = starUpBtn ? starUpBtn.closest('.fss-starup-wrap') : null;
  if (starUpBtn) {
    var HISTORY_KEY = 'fss-curve-history';
    var PI50 = '3.14159265358979323846264338327950288419716939937510'; /* π to 50 decimals */

    var curveHistory = (function () {
      try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); }
      catch (e) { return []; }
    })();

    /* High-resolution timestamp (nanosecond-padded) in both PST and EST. */
    function fmtZone(d, tz, nanoStr, label) {
      var p = {};
      new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      return p.year + '-' + p.month + '-' + p.day + ' ' +
        p.hour + ':' + p.minute + ':' + p.second + '.' + nanoStr + ' ' + label;
    }
    function nanoStamp() {
      var d = new Date();
      var perf = (window.performance && performance.now) ? performance.now() : 0;
      var subMs = perf - Math.floor(perf);                 /* fractional ms */
      var nanos = d.getMilliseconds() * 1e6 + Math.floor(subMs * 1e6);
      var nanoStr = String(Math.min(999999999, nanos)).padStart(9, '0');
      return {
        pst: fmtZone(d, 'America/Los_Angeles', nanoStr, 'PST'),
        est: fmtZone(d, 'America/New_York', nanoStr, 'EST')
      };
    }

    function genCurve() {
      var a, b, disc;
      do {
        a = Math.floor(Math.random() * 11) - 5;   /* -5..5 */
        b = Math.floor(Math.random() * 8) + 1;    /*  1..8 */
        disc = 4 * a * a * a + 27 * b * b;         /* singular iff 0 */
      } while (disc === 0);
      var eq = 'y² = x³ ' + (a >= 0 ? '+ ' + a : '- ' + (-a)) + 'x ' +
        (b >= 0 ? '+ ' + b : '- ' + (-b));
      var ts = nanoStamp();
      return {
        a: a, b: b, disc: disc, eq: eq,
        C: Math.random().toFixed(5),          /* random decimal */
        D: (Math.random() * 10).toFixed(5),   /* random decimal */
        pst: ts.pst, est: ts.est
      };
    }
    function recordCurve() {
      var c = genCurve();
      curveHistory.push(c);
      if (curveHistory.length > 200) curveHistory = curveHistory.slice(-200);
      try { localStorage.setItem(HISTORY_KEY, JSON.stringify(curveHistory)); } catch (e) {}
      return c;
    }
    function downloadHistory() {
      var blocks = curveHistory.map(function (e) {
        return [
          'Five Star Silver — Elliptic Curve',
          '',
          e.eq,
          '',
          'a = ' + e.a,
          'b = ' + e.b,
          'C = ' + e.C,
          'D = ' + e.D,
          'E = ' + PI50,
          'Discriminant Δ = -16(4a³ + 27b²) = ' + (-16 * e.disc),
          '',
          'Generated (PST): ' + e.pst,
          'Generated (EST): ' + e.est
        ].join('\n');
      });
      var text = blocks.join('\n\n--------------------------------------\n\n') + '\n';
      try {
        var blob = new Blob([text], { type: 'text/plain' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = 'five-star-elliptic-curves.txt';
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          try { document.body.removeChild(link); } catch (e) {}
          URL.revokeObjectURL(url);
        }, 1000);
      } catch (e) {}
    }

    /* ---- dropdown menu ---- */
    var starUpOpen = false;
    /* Scrim that darkens the site while the profile menu is open. */
    var profileBackdrop = document.createElement('div');
    profileBackdrop.className = 'fss-profile-backdrop';
    profileBackdrop.setAttribute('hidden', '');
    document.body.appendChild(profileBackdrop);
    function openMenu() {
      if (starUpMenu) { starUpMenu.hidden = false; starUpBtn.setAttribute('aria-expanded', 'true'); }
      profileBackdrop.removeAttribute('hidden');
      requestAnimationFrame(function () { profileBackdrop.classList.add('open'); });
      if (starWrap) starWrap.classList.add('fss-profile-open');
    }
    function closeMenu() {
      if (starUpMenu) { starUpMenu.hidden = true; starUpBtn.setAttribute('aria-expanded', 'false'); }
      profileBackdrop.classList.remove('open');
      setTimeout(function () { if (!starUpOpen) profileBackdrop.setAttribute('hidden', ''); }, 220);
      if (starWrap) starWrap.classList.remove('fss-profile-open');
    }
    profileBackdrop.addEventListener('click', function () { if (starUpOpen) deselectStars(); });
    document.addEventListener('click', function (e) {
      if (!starUpMenu || starUpMenu.hidden) return;
      if (starUpBtn.contains(e.target) || starUpMenu.contains(e.target)) return;
      /* Clicked outside while menu open — deselect (5 float → 1) + close */
      deselectStars();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && starUpOpen) {
        deselectStars();
      }
    });
    /* Blob items — placeholders until the CockroachDB-backed account system is wired up. */
    if (starUpMenu) {
      starUpMenu.querySelectorAll('.fss-starup-blob').forEach(function (blob) {
        blob.addEventListener('click', function (e) {
          if (blob.getAttribute('href') === '#') e.preventDefault();
          deselectStars();
        });
      });
    }

    /* ---- Star-up physics: 5 stars bounce inside the button box ----
       Stars are permanent (no fade). First click spawns them from center.
       Subsequent clicks kick them from wherever they settled.
       The canvas is sized and positioned to overlay the button exactly. */
    var starUpCanvas = document.getElementById('starup-canvas');
    var starUpCtx = starUpCanvas ? starUpCanvas.getContext('2d') : null;
    var starUpParticles = [];   /* persistent — never cleared between clicks */
    var starUpAnim = null;
    var SUP_GRAVITY = 0.35;
    var SUP_BOUNCE = 0.45;
    var SUP_DRAG = 0.985;
    var SUP_STAR = 9;           /* star draw size (px) */
    var SUP_R = 3.5;            /* collision radius */

    var SUP_PAIR_BOUNCE = 0.4;  /* restitution between star-up particles */
    var starUpCollapsing = false; /* true while stars converge to idle */
    var starUpPhase = 'idle';     /* 'idle' | 'post-merge' | 'fall' | 'float' */
    var starUpFallTimeout = null;
    var starFloatT = 0;           /* bob timer for the floating (profile) state */
    var starBounceCount = 0;      /* bounces left in the merge → bounce → shrink → float deselect anim */

    /* Startup / reset: the resting star jumps twice, then settles into the floating
       profile (head-and-shoulders). Used on load and after a click sequence resets. */
    function starJumpKick() {
      if (starUpParticles.length !== 1 || starUpPhase !== 'idle') return;
      var p = starUpParticles[0];
      p.vy = -(2.6 + Math.random() * 0.9);
      p.vx = (Math.random() - 0.5) * 1.1;
      p.rotSpeed = (Math.random() - 0.5) * 0.22;
      if (!starUpAnim) animateStarUp();
    }
    function starToFloat() {
      if (starUpParticles.length !== 1) return;
      var p = starUpParticles[0];
      /* One smooth upward pop; the float spring catches it at the head with no fall-first. */
      p.vy = -3.6; p.vx = 0;
      p.rotSpeed = (Math.random() - 0.5) * 0.12;
      starUpPhase = 'float'; starFloatT = 0;
      if (!starUpAnim) animateStarUp();
    }
    function startJumpFloatSequence() {
      setTimeout(starToFloat, 700);     /* rest briefly, then a single smooth jump up into the floating head */
    }

    function animateStarUp() {
      if (!starUpCanvas || !starUpCtx) { starUpAnim = null; return; }
      var w = starUpCanvas.width;
      var h = starUpCanvas.height;
      starUpCtx.clearRect(0, 0, w, h);
      var canDraw = !!(starImage && starLoaded);
      var isDark = document.documentElement.classList.contains('dark');
      var anyMoving = false;
      var i, j, a, b, dx, dy, dist, minDist, nx, ny, overlap, rvx, rvy, velAlong, imp;

      /* Integrate physics + wall constraints */
      var _cx = w / 2, _cy = h / 2;
      starUpParticles.forEach(function (p) {
        if (starUpCollapsing) {
          /* Pull toward center — no gravity, heavy damping */
          var _dx = _cx - p.x, _dy = _cy - p.y;
          var _d = Math.sqrt(_dx * _dx + _dy * _dy) || 0.0001;
          var _f = Math.min(_d * 0.18, 3.5);
          p.vx += (_dx / _d) * _f;
          p.vy += (_dy / _d) * _f;
          p.vx *= 0.68; p.vy *= 0.68;
        } else if (starUpPhase === 'fall') {
          p.vy += SUP_GRAVITY * 1.5;
          p.vx *= 0.97;
        } else if (starUpPhase === 'float') {
          /* Hover at a "head" position (upper-centre) with a gentle bob — no gravity.
             The star reads as the head above the drawn shoulders → a profile icon. */
          starFloatT += 0.045;
          var _hx = _cx;
          var _hy = _cy - h * 0.16 + Math.sin(starFloatT) * (h * 0.05);
          p.vx += (_hx - p.x) * 0.09; p.vy += (_hy - p.y) * 0.09;
          p.vx *= 0.80; p.vy *= 0.80;
          p.rotSpeed *= 0.92;
        } else {
          p.vy += SUP_GRAVITY;
          p.vx *= SUP_DRAG;
        }
        p.x += p.vx; p.y += p.vy;
        p.rot += p.rotSpeed; p.rotSpeed *= 0.97;
        if (!starUpCollapsing && starUpPhase !== 'fall' && starUpPhase !== 'float') {
          if (p.x - SUP_R < 0)  { p.x = SUP_R;     p.vx =  Math.abs(p.vx) * SUP_BOUNCE; }
          if (p.x + SUP_R > w)  { p.x = w - SUP_R;  p.vx = -Math.abs(p.vx) * SUP_BOUNCE; }
          if (p.y - SUP_R < 0)  { p.y = SUP_R;     p.vy =  Math.abs(p.vy) * SUP_BOUNCE; }
          if (p.y + SUP_R > h)  {
            p.y = h - SUP_R;
            if (starUpPhase === 'bounce') {
              /* Merge-bounce: count each floor bounce, shrink the star, re-kick it around
                 the button, and after 5 bounces settle into the small floating head. */
              starBounceCount += 1;
              p.scale = Math.max(1, 2.1 - starBounceCount * 0.22);
              if (starBounceCount >= 5) {
                p.scale = 1; starUpPhase = 'float'; starFloatT = 0;
              } else {
                p.vy = -(3.3 - starBounceCount * 0.35);
                p.vx = (Math.random() - 0.5) * 4.2;
                p.rotSpeed = (Math.random() - 0.5) * 0.3;
              }
            } else {
              p.vy = -Math.abs(p.vy) * SUP_BOUNCE;
              p.vx *= 0.82;
              if (Math.abs(p.vy) < 0.4) p.vy = 0;
            }
          }
        }
        var speed = Math.abs(p.vx) + Math.abs(p.vy);
        if (speed > 0.15) anyMoving = true;
      });

      /* Star-to-star collision (O(n²), fine for 5 particles) */
      for (i = 0; i < starUpParticles.length; i++) {
        for (j = i + 1; j < starUpParticles.length; j++) {
          a = starUpParticles[i]; b = starUpParticles[j];
          dx = b.x - a.x; dy = b.y - a.y;
          dist = Math.sqrt(dx * dx + dy * dy) || 0.0001;
          minDist = SUP_R * 2;
          if (dist < minDist) {
            nx = dx / dist; ny = dy / dist;
            overlap = (minDist - dist) / 2;
            a.x -= nx * overlap; a.y -= ny * overlap;
            b.x += nx * overlap; b.y += ny * overlap;
            rvx = b.vx - a.vx; rvy = b.vy - a.vy;
            velAlong = rvx * nx + rvy * ny;
            if (velAlong < 0) {
              imp = -(1 + SUP_PAIR_BOUNCE) * velAlong / 2;
              a.vx -= imp * nx; a.vy -= imp * ny;
              b.vx += imp * nx; b.vy += imp * ny;
            }
          }
        }
      }

      /* Convergence check — snap to idle once all stars reach center */
      if (starUpCollapsing) {
        var _allNear = true;
        for (var _ci = 0; _ci < starUpParticles.length; _ci++) {
          var _cp = starUpParticles[_ci];
          if (Math.abs(_cp.x - _cx) > 3.5 || Math.abs(_cp.y - _cy) > 3.5) { _allNear = false; break; }
        }
        if (_allNear) {
          /* 5 stars merged → the single floating profile head. */
          starUpCollapsing = false;
          starUpParticles.length = 0;
          starUpParticles.push({ x: _cx, y: _cy, vx: 0, vy: 0, rot: 0, rotSpeed: 0 });
          starUpPhase = 'float'; starFloatT = 0;
        } else {
          anyMoving = true;
        }
      }

      /* Fall exit — star dropped off canvas, reset to idle */
      if (starUpPhase === 'fall') {
        if (starUpParticles.length === 1 && starUpParticles[0].y > h + 40) {
          starUpPhase = 'idle';
          starUpParticles.length = 0;
          starUpParticles.push({ x: w / 2, y: h - SUP_R - 1, vx: 0, vy: 0, rot: 0, rotSpeed: 0 });
          /* After a click sequence resets, settle back into the floating profile. */
          setTimeout(starToFloat, 350);
        } else {
          anyMoving = true;
        }
      }

      /* Draw — always black; the canvas element is CSS-inverted to white in dark mode
         (ctx.filter='invert' doesn't reliably affect drawImage on iOS Safari). */
      starUpParticles.forEach(function (p) {
        var sc = p.scale || 1;                         /* per-star scale (big → small on merge-bounce) */
        if (canDraw) {
          starUpCtx.save();
          starUpCtx.translate(p.x, p.y);
          starUpCtx.rotate(p.rot);
          var ss = SUP_STAR * sc;
          starUpCtx.drawImage(starImage, -ss / 2, -ss / 2, ss, ss);
          starUpCtx.restore();
        } else {
          starUpCtx.save();
          starUpCtx.fillStyle = '#111';
          starUpCtx.beginPath();
          starUpCtx.arc(p.x, p.y, SUP_R * sc, 0, Math.PI * 2);
          starUpCtx.fill();
          starUpCtx.restore();
        }
      });

      /* Shoulders are a crisp SVG (not canvas) toggled by a class — shown whenever the
         menu is CLOSED and the profile is resting/floating (incl. the 5 floating stars on
         deselect), hidden while the menu is open (clicked). */
      var shouldersOn = !starUpOpen && (starUpPhase === 'float' || starUpPhase === 'bounce' || starUpParticles.length > 1 || starUpCollapsing);
      if (starWrap) starWrap.classList.toggle('fss-shoulders-on', shouldersOn);

      if (anyMoving || starUpCollapsing || starUpPhase === 'float' || starUpPhase === 'bounce') {
        starUpAnim = requestAnimationFrame(animateStarUp);
      } else {
        starUpAnim = null;
      }
    }

    function burstStarUpCanvas() {
      if (!starUpCanvas) return;
      starUpCollapsing = false;
      starUpPhase = 'idle';
      if (starUpFallTimeout) { clearTimeout(starUpFallTimeout); starUpFallTimeout = null; }
      /* Canvas is position:absolute inside .fss-starup-wrap, so it inherits the
         button's z-index context and won't overlay the search bar. Size it to
         the button's layout rect (same as the wrapper's size). */
      var rect = starUpBtn.getBoundingClientRect();
      var w = Math.round(rect.width);
      var h = Math.round(rect.height);
      starUpCanvas.width = w;
      starUpCanvas.height = h;
      starUpCanvas.style.width  = w + 'px';
      starUpCanvas.style.height = h + 'px';
      /* left/top are 0 (absolute within wrapper) — no viewport coords needed */

      var cx = w / 2, cy = h / 2;

      if (starUpParticles.length === 0) {
        /* No idle star yet: spawn 5 from center */
        var sbi = document.getElementById('star-btn-img');
        if (sbi) sbi.style.opacity = '0';
        for (var i = 0; i < 5; i++) {
          var angle = (i / 5) * Math.PI * 2 - Math.PI / 2;
          var speed = 2.2 + Math.random() * 2;
          starUpParticles.push({
            x: cx, y: cy,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            rot: Math.random() * Math.PI * 2,
            rotSpeed: (Math.random() - 0.5) * 0.25
          });
        }
      } else if (starUpParticles.length === 1) {
        /* Idle star: promote to 5 by spawning 4 more from same position, then kick all */
        var base = starUpParticles[0];
        for (var i = 0; i < 4; i++) {
          var angle = ((i + 1) / 5) * Math.PI * 2 - Math.PI / 2;
          starUpParticles.push({
            x: base.x, y: base.y,
            vx: 0, vy: 0,
            rot: Math.random() * Math.PI * 2,
            rotSpeed: (Math.random() - 0.5) * 0.25
          });
        }
        starUpParticles.forEach(function (p) {
          var angle = Math.random() * Math.PI * 2;
          var speed = 2.2 + Math.random() * 2;
          p.vx = Math.cos(angle) * speed;
          p.vy = Math.sin(angle) * speed;
          p.rotSpeed = (Math.random() - 0.5) * 0.25;
        });
      } else {
        /* Already 5: kick from settled positions */
        starUpParticles.forEach(function (p) {
          var angle = Math.random() * Math.PI * 2;
          var speed = 2 + Math.random() * 2.5;
          p.vx = Math.cos(angle) * speed;
          p.vy = Math.sin(angle) * speed;
          p.rotSpeed = (Math.random() - 0.5) * 0.25;
        });
      }
      if (!starUpAnim) animateStarUp();
    }

    /* ---- Collapse back to 1 idle star after menu closes ---- */
    function collapseToIdleStar() {
      if (!starUpCanvas || !starUpBtn) return;
      var rect = starUpBtn.getBoundingClientRect();
      var w = Math.round(rect.width) || 36;
      var h = Math.round(rect.height) || 36;
      starUpCanvas.width = w;
      starUpCanvas.height = h;
      starUpCanvas.style.width  = w + 'px';
      starUpCanvas.style.height = h + 'px';
      if (starUpParticles.length <= 1) {
        /* Already 0 or 1 — settle straight into the floating profile head. */
        starUpParticles.length = 0;
        starUpParticles.push({ x: w / 2, y: h / 2, vx: 0, vy: 0, rot: 0, rotSpeed: 0 });
        starUpPhase = 'float'; starFloatT = 0;
        if (!starUpAnim) animateStarUp();
        return;
      }
      /* Animate all 5 stars merging into center, then float (see convergence check). */
      starUpCollapsing = true;
      if (!starUpAnim) animateStarUp();
    }

    /* Deselect: keep the 5 stars FLOATING (shoulders return under them) for 2s, then merge
       back into 1 floating star. */
    var starDeselectTimer = null;
    function deselectStars() {
      starUpOpen = false;
      closeMenu();
      if (starDeselectTimer) { clearTimeout(starDeselectTimer); starDeselectTimer = null; }
      /* Deselect: the 5 stars float up together, then merge into ONE floating star. */
      if (starUpParticles.length > 1) {
        starUpPhase = 'float'; starFloatT = 0;
        if (!starUpAnim) animateStarUp();
        starDeselectTimer = setTimeout(function () { starDeselectTimer = null; collapseToIdleStar(); }, 900);
      } else {
        collapseToIdleStar();
      }
    }

    /* ---- Idle rumble every 5 s — restartable ---- */
    var starIdleInterval = null;
    function startIdleInterval() {
      if (starIdleInterval) clearInterval(starIdleInterval);
      starIdleInterval = setInterval(function () {
        if (starUpParticles.length !== 1 || starUpPhase !== 'idle') return;
        var p = starUpParticles[0];
        var angle = Math.random() * Math.PI * 2;
        var speed = 1.2 + Math.random() * 1.4;
        p.vx = Math.cos(angle) * speed;
        p.vy = Math.sin(angle) * speed;
        p.rotSpeed = (Math.random() - 0.5) * 0.2;
        if (!starUpAnim) animateStarUp();
      }, 5000);
    }

    /* ---- Auto-spawn 1 idle star at bottom of button on startup ---- */
    (function initIdleStar() {
      if (!starUpCanvas || !starUpBtn) return;
      var rect = starUpBtn.getBoundingClientRect();
      var w = Math.round(rect.width) || 36;
      var h = Math.round(rect.height) || 36;
      starUpCanvas.width = w;
      starUpCanvas.height = h;
      starUpCanvas.style.width  = w + 'px';
      starUpCanvas.style.height = h + 'px';
      /* Hide static img — the canvas star takes over immediately */
      var sbi = document.getElementById('star-btn-img');
      if (sbi) sbi.style.opacity = '0';
      /* Place 1 star resting at bottom centre */
      starUpParticles.push({
        x: w / 2, y: h - SUP_R - 1,
        vx: 0, vy: 0,
        rot: 0, rotSpeed: 0
      });
      /* Wait for the star image before drawing, to avoid showing the circle fallback */
      function doAnim() { animateStarUp(); startJumpFloatSequence(); }
      if (starLoaded) {
        doAnim();
      } else {
        var waitImg = starImage;
        var waited = false;
        function onLoad() {
          if (waited) return; waited = true;
          waitImg.removeEventListener('load', onLoad);
          doAnim();
        }
        waitImg.addEventListener('load', onLoad);
        /* Failsafe: start anyway after 2 s even if the image never fires */
        setTimeout(function () { if (!waited) { waited = true; doAnim(); } }, 2000);
      }
    })();

    /* Re-size the canvas to the button's current box (used after the button is
       moved between the header and the sticky search bar, since the two boxes
       are different sizes). Keeps the idle star resting at the new bottom. */
    function resizeStarUpCanvas() {
      if (!starUpCanvas || !starUpBtn) return;
      var r = starUpBtn.getBoundingClientRect();
      var w = Math.round(r.width) || 36, h = Math.round(r.height) || 36;
      if (!w || !h) return;
      starUpCanvas.width = w; starUpCanvas.height = h;
      starUpCanvas.style.width = w + 'px'; starUpCanvas.style.height = h + 'px';
      if (starUpParticles.length === 1 && starUpPhase === 'idle') {
        starUpParticles[0].x = w / 2;
        starUpParticles[0].y = h - SUP_R - 1;
      }
      if (!starUpAnim) animateStarUp();
    }
    window.fssStarUpResize = resizeStarUpCanvas;

    /* ---- click: toggle burst ↔ collapse ---- */
    starUpBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (starUpOpen) {
        /* Already open — deselect: the 5 stars float, then merge back to 1 */
        deselectStars();
      } else {
        /* Closed — burst stars and open menu (cancel any pending 2 s merge) */
        starUpOpen = true;
        if (starDeselectTimer) { clearTimeout(starDeselectTimer); starDeselectTimer = null; }
        if (starIdleInterval) { clearInterval(starIdleInterval); starIdleInterval = null; }
        if (window.fssRevealSell) window.fssRevealSell();
        burstStarUpCanvas(e);
        openMenu();
      }
    });
  }

  /* ---- ADMIN LIVE-EDIT: double-click the modal title or description to edit,
     then Save. Admin only (client shows it for the admin email; the server
     verifies the Google token before writing to Shopify). ---- */
  (function () {
    var overlay = document.getElementById('product-modal-overlay');
    if (!overlay) return;
    var serverUrl = (window.fss && window.fss.paymentServerUrl) || '';
    function admin() {
      try { var u = JSON.parse(localStorage.getItem('fss_user')); return (u && u.email === 'theodorepalsercontact@gmail.com' && u.id_token) ? u : null; }
      catch (e) { return null; }
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function htmlToText(h) { var d = document.createElement('div'); d.innerHTML = h; return d.textContent; }
    function textToHtml(t) { return esc(t).replace(/\n/g, '<br>'); }

    overlay.addEventListener('dblclick', function (e) {
      var el = e.target.closest('[data-edit]');
      if (!el || el.querySelector('.fss-edit-box')) return;
      var u = admin();
      if (!u) return;
      startEdit(el, el.dataset.edit, el.dataset.pid, u);
    });

    function startEdit(el, field, pid, u) {
      var isTitle = field === 'title';
      var isPrice = field === 'price';
      var original = el.innerHTML;
      var box = document.createElement('div');
      box.className = 'fss-edit-box';
      var input = document.createElement((isTitle || isPrice) ? 'input' : 'textarea');
      input.className = 'fss-edit-input';
      if (isPrice) { input.type = 'number'; input.step = '0.01'; input.min = '0'; }
      input.value = isTitle ? el.textContent.trim() : (isPrice ? el.textContent.replace(/[^0-9.]/g, '') : 'Loading…');
      if (!isTitle && !isPrice) input.disabled = true;
      var bar = document.createElement('div');
      bar.className = 'fss-edit-bar';
      bar.innerHTML = '<button type="button" class="fss-edit-save">Save</button>' +
        '<button type="button" class="fss-edit-cancel">Cancel</button>' +
        '<span class="fss-edit-msg"></span>';
      box.appendChild(input); box.appendChild(bar);
      el.innerHTML = ''; el.appendChild(box);
      input.focus();

      if (!isTitle && !isPrice && serverUrl) {
        fetch(serverUrl + '/api/admin/product/' + encodeURIComponent(pid))
          .then(function (r) { return r.json(); })
          .then(function (d) { input.value = htmlToText(d.body_html || ''); input.disabled = false; input.focus(); })
          .catch(function () { input.value = htmlToText(original); input.disabled = false; });
      }
      function close(restore) { el.innerHTML = restore; }
      bar.querySelector('.fss-edit-cancel').addEventListener('click', function () { close(original); });
      bar.querySelector('.fss-edit-save').addEventListener('click', function () {
        var msg = bar.querySelector('.fss-edit-msg');
        var body = { id_token: u.id_token, id: pid };
        if (isTitle) body.title = input.value; else if (isPrice) body.price = input.value; else body.body_html = textToHtml(input.value);
        msg.textContent = 'Saving…';
        fetch(serverUrl + '/api/admin/update-product', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d && res.d.error || 'save failed');
            close(isTitle ? esc(res.d.title) : (isPrice ? ('$' + Number(res.d.price != null ? res.d.price : input.value).toFixed(2)) : (res.d.body_html || textToHtml(input.value))));
          })
          .catch(function (err) { msg.textContent = 'Error: ' + err.message; });
      });
    }
  })();

  /* ---- INIT: fetch cart on load ---- */
  fetchCart();

})();

/* ---- TRON GRID SHIMMER ---- */
(function () {
  var canvas = document.getElementById('tron-grid-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var CELL = 26;
  var shimmers = [];

  function resize() {
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  function spawnShimmer() {
    if (document.documentElement.classList.contains('dark')) return;
    var cols = Math.floor(canvas.width  / CELL);
    var rows = Math.floor(canvas.height / CELL);
    var gw = 2 + Math.floor(Math.random() * 4); /* 2–5 cells wide */
    var gh = 2 + Math.floor(Math.random() * 4); /* 2–5 cells tall */
    var gx = 1 + Math.floor(Math.random() * Math.max(1, cols - gw - 1));
    var gy = 1 + Math.floor(Math.random() * Math.max(1, rows - gh - 1));
    shimmers.push({ gx: gx, gy: gy, gw: gw, gh: gh, alpha: 0, phase: 'in', hold: 0 });
  }

  function scheduleNext() {
    setTimeout(function () { spawnShimmer(); scheduleNext(); },
      5000 + Math.random() * 6000);
  }
  scheduleNext();

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var isDark = document.documentElement.classList.contains('dark');
    if (!isDark) {
      shimmers = shimmers.filter(function (s) {
        /* Fade logic */
        if (s.phase === 'in')   { s.alpha += 0.025; if (s.alpha >= 0.16) { s.alpha = 0.16; s.phase = 'hold'; } }
        else if (s.phase === 'hold') { s.hold++; if (s.hold > 28) s.phase = 'out'; }
        else { s.alpha -= 0.018; if (s.alpha <= 0) return false; }

        var x0 = s.gx * CELL, y0 = s.gy * CELL;
        var x1 = x0 + s.gw * CELL, y1 = y0 + s.gh * CELL;

        ctx.save();
        ctx.globalAlpha = s.alpha;
        ctx.strokeStyle = '#b8cede';
        ctx.lineWidth   = 0.75;

        /* Grid lines */
        ctx.beginPath();
        for (var ci = 0; ci <= s.gw; ci++) { var lx = x0 + ci * CELL; ctx.moveTo(lx, y0); ctx.lineTo(lx, y1); }
        for (var ri = 0; ri <= s.gh; ri++) { var ly = y0 + ri * CELL; ctx.moveTo(x0, ly); ctx.lineTo(x1, ly); }
        ctx.stroke();

        /* Corner nodes */
        ctx.fillStyle = '#c8dcea';
        for (var ni = 0; ni <= s.gw; ni++) {
          for (var nj = 0; nj <= s.gh; nj++) {
            ctx.beginPath();
            ctx.arc(x0 + ni * CELL, y0 + nj * CELL, 1.4, 0, Math.PI * 2);
            ctx.fill();
          }
        }
        ctx.restore();
        return true;
      });
    }
    requestAnimationFrame(draw);
  }
  draw();
})();

/* ---- TOP NAV: filter links that carry a data-filter-tag ---- */
(function () {
  $$('.fss-top-nav-panel-link[data-filter-tag]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var tag = this.dataset.filterTag;
      var href = this.getAttribute('href') || '';
      /* If we're already on the target page (or href is just /marketplace), apply filter directly */
      var onMarketplace = window.location.pathname.indexOf('/marketplace') !== -1 ||
                          window.location.pathname === '/' ||
                          document.getElementById('tag-bubbles');
      if (onMarketplace && tag) {
        e.preventDefault();
        var bubble = document.querySelector('.fss-bubble-cat[data-tag="' + tag + '"]');
        if (bubble) {
          bubble.click();
        } else if (typeof activeTag !== 'undefined') {
          activeTag = tag;
          if (typeof setCategorySubs === 'function') setCategorySubs(tag);
          if (typeof applyFilters === 'function') applyFilters();
        }
      }
      /* Otherwise let normal navigation happen (will land on /marketplace with no filter) */
    });
  });
})();

/* ---- CUSTOM MODULE EFFECTS (IntersectionObserver) ---- */
(function () {
  var effectModules = document.querySelectorAll(
    '.fss-module-effect-fade-in,.fss-module-effect-slide-up,.fss-module-effect-slide-left,.fss-module-effect-slide-right,.fss-module-effect-zoom-in'
  );
  if (!effectModules.length) return;
  if (!window.IntersectionObserver) {
    effectModules.forEach(function (el) { el.classList.add('fss-module-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fss-module-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  effectModules.forEach(function (el) { obs.observe(el); });
})();

/* ---- STAR SHOOT ANIMATION (fires on nav drawer open) ---- */
window.fssShootStars = function () {
  var chars = ['★', '✦', '★', '✦', '★'];
  chars.forEach(function (ch, i) {
    var el = document.createElement('div');
    el.className = 'fss-shooting-star';
    el.textContent = ch;
    el.style.top = (15 + Math.random() * 70) + 'vh';
    el.style.animationDelay = (i * 90) + 'ms';
    el.style.fontSize = (13 + Math.random() * 9) + 'px';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.addEventListener('animationend', function () { el.remove(); });
  });
};

/* Typing animation and hamburger→nav-bubble logic moved to inline script in homepage.liquid */
